<template>
  <div class="tab-container">
    <!-- 5万プランのヒト向け -->
    <div class="plan-tag" v-if="isPlan('plan') && !isOK">
      <a style="font-size: 32px; font-weight: 600; color: white; position: absolute; right: 24px; top: 15px;" @click="isOK=true">×</a>
      <p>ライトプランのお客様へ</p>
      <hr>
      <p>ロボの台数の上限に達しました。（上限：{{planLimit}}）</p>
      <p>新しいロボを使用するには、アーカイブも含めて既存のロボを一台削除またはロックを解除するか、スタンダードプランへの移行が必要です。</p>
    </div>
    <ModalStoreUpload ref="storeup"/>
    <div class="mask" v-if="isDetailHover"></div>
    <div class="header-cb" v-if="!$route.query.view">
      <div>
        <p><b style="font-size:28px; font-weight: 800;">Robot</b></p>
        <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">ロボの状態</p>
      </div>
      <div>
        <p style="color: #EE2C98;">台数 [ {{chatbots.length}}台 ] / 月間使用回数 [ {{user.botLeft}}回 ]</p>
        <a class="button is-primary" style="margin-left: 25px;" @click="openStore()"><span class="mdi mdi-shopping" style="margin-right: 10px;"></span>ロボストア</a>
        <div style="margin-left: 25px;" v-if="isPlan('limit') && !$route.query.view">
          <b-tooltip label="新しいロボを作成する" position="is-bottom">
            <a class="button is-primary" @click="createChatBot()">
              <span class="mdi mdi-plus"></span>ロボを作成
            </a>
          </b-tooltip>
        </div>
        <div style="margin-left: 25px;" v-if="$route.query.view">
          <a class="button is-primary" @click="changeList()">
            ロボ倉庫へ
          </a>
        </div>
      </div>
    </div>
    <!-- モーダル START -->
    <b-modal width="680px" :active.sync="isModalStartURL" style="z-index: 300;">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
              URL一覧
            </p>
          </div>
        </header>
        <div class="card-content" style="white-space: pre-line; text-align: left; overflow-y: scroll;">
          {{getTargetUrl(setShowURL)}}
        </div>
        <hr>
        <button class="button is-primary" style="margin-bottom: 24px;" @click="isModalStartURL=false;setShowURL=''">戻る</button>
      </div>
    </b-modal>
    <!-- ミニロボ追加時メッセージ -->
    <b-modal width="680px" :active.sync="isModalAddMiniBot" style="z-index: 300;">
      <div class="card" style="border-radius: 5px; margin-top: 24px;">
        <b-field style="margin-top: 5hv;">
          <b style="font-size: 1.0em;">ミニロボ作成</b>
        </b-field>
        <b-field style="margin-top: 5vh;">
          <b-message type="is-danger" style="font-size: 0.85em;" has-icon>
            ※本ロボが、既に設置済みであったり、求人ページに掲載している場合、<br/>
            設置設定されているURLを初期化、公開設定も初期化しますので、<br/>
            ご注意ください。<br/>
          </b-message>
        </b-field>
        <hr>
        <b-field style="width: 100%;">
          <div style="width: 50%;">
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="clearModalInfo()">
              キャンセル
            </button>
          </div>
          <div style="width: 50%;">
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="createChatBotMini(cbInfo);clearModalInfo()">
              ミニロボを作成する
            </button>
          </div>
        </b-field>
      </div>
    </b-modal>
    <!-- 起動URL設定時メッセージ -->
    <b-modal width="680px" :active.sync="isModalUrlSet" style="z-index: 300;">
      <div class="card" style="border-radius: 5px; margin-top: 24px;">
        <b-field style="margin-top: 5hv;">
          <b style="font-size: 1.0em;" v-if="isModalUrlSetBot||isModalUrlSetMiniBot">起動URL設定</b>
          <b style="font-size: 1.0em;" v-if="isModalUrlDeleteBot||isModalUrlDeleteMiniBot">起動URL解除</b>
        </b-field>
        <b-field style="margin-top: 5vh;">
          <b-message type="is-danger" style="font-size: 0.85em;" has-icon v-if="isModalUrlSetBot||isModalUrlSetMiniBot">
            ※本ロボが、既に設置済みであったり、求人ページに掲載している場合、<br/>
            設置設定されているURLを初期化して新たに設定しますので、<br/>
            ご注意ください。<br/>
            個別に設定したい場合は「<a @click="clearModalInfo();changeSitemap();">起動設定画面</a>」より設定を行ってください。<br/>
          </b-message>
          <b-message type="is-danger" style="font-size: 0.85em;" has-icon v-if="isModalUrlDeleteBot||isModalUrlDeleteMiniBot">
            ※本ロボの起動URLを全て解除します。<br/>
            個別に設定したい場合は「<a @click="clearModalInfo();changeSitemap();">起動設定画面</a>」より設定を行ってください。<br/>
          </b-message>
        </b-field>
        <hr>
        <b-field style="width: 100%;">
          <div style="width: 50%;">
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="cancelModalInfo();">
              キャンセル
            </button>
          </div>
          <div style="width: 50%;">
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="cancelModalInfo();applyRoboSitemap(false, tabIdx >= 0 ? false : true, 'robo-apply');" v-if="isModalUrlSetBot">
              ロボ起動URL設定
            </button>
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="cancelModalInfo();selectedGroup=[modalFooterUrl];applyRoboSitemap(true, tabIdx >= 0 ? false : true, 'robo-apply');" v-if="isModalUrlSetMiniBot">
              ミニロボ起動URL設定
            </button>
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="cancelModalInfo();complateUnapplyRoboSitemap(false, 'robo-unapply');" v-if="isModalUrlDeleteBot">
              ロボ起動URL解除
            </button>
            <button class="button is-primary" style="width: 95%; margin-left: 10px; margin-right: 10px; margin-bottom: 24px;" @click="cancelModalInfo();selectedGroup=[modalFooterUrl];complateUnapplyRoboSitemap(true, 'robo-unapply');" v-if="isModalUrlDeleteMiniBot">
              ミニロボ起動URL解除
            </button>
          </div>
        </b-field>
      </div>
    </b-modal>
    <b-modal width="680px" :active.sync="isCreateRoboPartsSetModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            パーツセットの新規作成
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-primary" has-icon>
              新規にパーツセットを作成します。
            </b-message>
          </p>
          <hr>
          <p style="padding-bottom: 0.5em;"><b>パーツセット名</b></p>
          <b-input v-model="roboPartsSetName"></b-input>
          <p style="padding-bottom: 0.5em;padding-top: 0.5em;"><b>作成者</b></p>
          <b-input v-model="author"></b-input>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCreateRoboPartsSetModal = false">キャンセル</a>
          <a class="card-footer-item" @click="createRoboPartsSet()">作成</a>
        </footer>
      </div>
    </b-modal>
    <ModalDownloadTalkHistory ref="talkDownload"/>
    <!-- モーダル END -->
    <!-- Chatbot 詳細画面 -->
    <div style="height: 100%; width: calc(100% - 80px); background: rgba(0, 0, 0, 0.5); position: absolute; z-index: 200; top: 80px;" @click="modalFooterVar=null;modalFooterUrl=null;isChatbotInfo=false;cbInfo=null;isChatbotInfo;resetSeekerrSortedInfosState()" v-if="isChatbotInfo"></div>
    <transition name="right">
      <div style="position: absolute; top: 80px; right: 0; height: calc(100% - 80px); width: 65%; min-width: 400px; max-width: 800px; background: #FEFEFE; padding: 16px; z-index: 201; overflow-y: scroll;" v-if="isChatbotInfo">
        <!-- header -->
        <div style="display: flex; justify-content: space-between; padding: 24px;">
          <div class="img-icon-128px" style="padding-top: 10px; padding-bottom: 10px;" @mouseover="roboIconHover = true" @mouseleave="roboIconHover = false">
            <Tooltip message="アイコンを変更する">
              <img class="chatbot-icon" :src="cbInfo.icon_data" v-if="cbInfo.icon_data&&!isIconLoading">
              <img class="chatbot-icon" src="@/assets/template/robot.png" v-if="!cbInfo.icon_data&&!isIconLoading">
            </Tooltip>
            <Tooltip message="アイコンを初期化する">
              <div class="delete-button" @click="deleteIcon(false, -1)" v-if="roboIconHover===true && isRoboEditPermission(cbInfo)">×</div>
            </Tooltip>
            <a style="margin-top: 8px;" class="button is-small" @click="modalActive(false, 0)" :disabled="!isRoboEditPermission(cbInfo)"><span class="mdi mdi-image-plus" style="margin-right: 5px;"></span>アイコン編集</a>
            <ModalSelectMedia @updated='setIcon'></ModalSelectMedia>
          </div>
          <div style="width: calc(100% - 128px); padding-left: 24px; text-align: left; font-size: x-large;">
            <p @click="isEditName=true" v-if="!isEditName"><b><span class="mdi mdi-square-edit-outline" style="margin-right: 10px;"></span>{{cbInfo.name}}</b></p>
            <div class="field has-addons" v-if="isEditName">
              <div class="control" style="width: -webkit-fill-available;">
                <input class="input" style="text-align: center;" @keydown.ctrl.enter="isEditName=false;$store.dispatch('chatbot/setChatBot', cbInfo)" @keydown.meta.enter="isEditName=false;$store.dispatch('chatbot/setChatBot', cbInfo)" v-model="cbInfo.name"/>
              </div>
              <div class="control">
                <button class="button is-primary" @click="isEditName=false;$store.dispatch('chatbot/setChatBot', cbInfo)">保存</button>
              </div>
            </div>
            <div style="display: flex; margin-top: 4px;">
              <p style="font-size: initial; color: #666; margin-left: 12px;"><span class="mdi mdi-message-text" style="margin-right: 4px;"></span>{{chatbotStatus.message_count}}</p>
              <p style="font-size: initial; color: #666; margin-left: 12px;"><span class="mdi mdi-account-check" style="margin-right: 4px;"></span>{{chatbotStatus.appoint_count}}</p>
              <p style="font-size: initial; color: #666; margin-left: 12px;"><span class="mdi mdi-message-reply" style="margin-right: 4px;"></span>{{chatbotStatus.reply_count}}</p>
              <p style="font-size: initial; color: #666; margin-left: 12px;"><span class="mdi mdi-account-location" style="margin-right: 4px;"></span>{{chatbotStatus.subscribe_count}}</p>
              <p style="font-size: initial; color: #666; margin-left: 12px;"><span class="mdi mdi-calendar" style="margin-right: 4px;"></span>{{showDate(cbInfo.created_at)}}</p>
            </div>
            <div style="margin-left: 12px;">
              <star-rating style="font-size: 12px; margin-top: 0; color: yellow;" :read-only="true" :increment="0.01" :rating="getScoreCB(cbInfo)" :star-size="24" :show-rating="false"></star-rating>
            </div>
          </div>
        </div>
        <!-- 内部 -->
        <b-tabs v-model="activeTabInfo">
          <b-tab-item label="メニュー">
            <div style="padding: 24px;">
              <div style="display: flex; margin-top: 16px; padding-bottom: 16px;">
                <div>
                  <p style="text-align: left; vertical-align: middle; width: 250px;"><b>基本メニュー</b></p>
                  <p style="text-align: left; font-size: x-small;" v-if="cbInfo.chatbot_mini.length >= 1">起動設定はミニロボリストの<br>配置設定から行ってください</p>
                </div>
                <div style="width: calc(100% - 250px);">
                  <button style="margin-top: 8px; width: 48%" class="button is-small" @click="isChatbotInfo=false;changeSitemap()" :disabled="cbInfo.chatbot_mini.length >= 1 || !cbInfo.is_confirm"><span class="mdi mdi-power"></span>起動設定</button>
                  <button style="margin-top: 8px; width: 48%" class="button is-small" @click="isChatbotInfo=false;setScenarioName(cbInfo.scenario_name, cbInfo)" :disabled="!isRoboEditPermission(cbInfo)"><span class="mdi mdi-tooltip-edit"></span>シナリオ</button>
                  <button style="margin-top: 8px; width: 48%" class="button is-small" @click="isChatbotInfo=false;copySinglePageURL(cbInfo)" :disabled="!cbInfo.is_confirm"><span class="mdi mdi-link-variant"></span>リンク</button>
                  <button style="margin-top: 8px; width: 48%" class="button is-small is-danger" @click="isChatbotInfo=false;deleteChatBot(cbInfoIndex)" :disabled="!isRoboEditPermission(cbInfo)"><span class="mdi mdi-delete"></span>削除</button>
                  <button style="margin-top: 8px; width: 48%" class="button is-small" @click="isChatbotInfo=false;$store.dispatch('chatbot/getScenario', { companyid: user.companyID, scenarioName: cbInfo['scenario_name'] });openStoreUpload(cbInfo)" :disabled="!user.isAgent&&cbInfo.is_store"><span class="mdi mdi-shopping" style="margin-right: 5px;"></span>ストア</button>
                  <a      style="margin-top: 8px; width: 48%" :href="makeLink(cbInfo.scenario_name)" target="_blank" rel="noopener" class="button is-small is-primary" :disabled="!isRoboEditPermission(cbInfo)"><span class="mdi mdi-play"></span>プレビュー</a>
                  <button style="margin-top: 8px; margin-right: calc(50% - 6px); width: 48%" class="button is-small is-danger" @click="isChatbotInfo=false;clickRoboLock(cbInfo)" v-if="!cbInfo.is_confirm" :disabled="!allPartsConfirm || errorCheck(scenario).length!=0"><span class="mdi mdi-lock"></span>ロボロック</button>
                  <button style="margin-top: 8px; margin-right: calc(50% - 6px); width: 48%" class="button is-small is-danger" @click="isChatbotInfo=false;clickRoboLock(cbInfo)" v-if="cbInfo.is_confirm" :disabled="!isRoboEditPermission(cbInfo)"><span class="mdi mdi-lock-open"></span>ロボロック解除</button>
                </div>
              </div>
              <div style="display: flex; margin-top: 16px;">
                <p style="text-align: left; vertical-align: middle; width: 250px;"><b><a href="https://hr-monster.io" target="_blank" rel="noopener">HRモンスター 求人ページ</a>へ<br/>の公開設定</b></p>
                <div style="width: calc(100% - 250px); margin-left: 16px; text-align: left;">
                  <button @click="cbInfo.is_recruit=true;  $store.dispatch('chatbot/setChatBot', cbInfo)" class="button is-primary is-small" v-if="!cbInfo.is_recruit" :disabled="!cbInfo.is_confirm">求人媒体に公開</button>
                  <button @click="cbInfo.is_recruit=false; $store.dispatch('chatbot/setChatBot', cbInfo)" class="button is-primary is-small" v-if="cbInfo.is_recruit">非公開にする</button>
                  <!-- <textarea style="margin-top: 4px; height: 100px; width: 100%;" class="textarea is-small" maxlength="300" placeholder="説明" v-model="cbInfo.description"></textarea> -->
                </div>
              </div>
              <div style="display: flex; margin-top: 16px;" v-if="isRoboEditPermission(cbInfo)">
                <p style="text-align: left; width: 250px;"><b>編集権限</b></p>
                <div style="width: calc(100% - 250px);">
                  <div style="display: flex; align-items: flex-start; flex-wrap: wrap; overflow-y: scroll; margin-top: 8px;">
                    <b-checkbox v-for="(us, idx2) in showUsers" :key="idx2" style="margin: 5px;" v-model="cbInfo.editor" :native-value="us.user_hash" :disabled="cbInfo.is_confirm || Boolean(cbInfo.create_by === us.user_hash) || !isRoboEditPermission(cbInfo)">
                      {{us.username}}
                    </b-checkbox>
                  </div>
                  <button @click="sendControlLog('ロボ編集権限変更', ''); cbInfo.permit_users={'users': permitList}; $store.dispatch('chatbot/setChatBot', cbInfo)" style="margin-top: 8px;" class="button is-primary is-small is-fullwidth">編集設定を反映する</button>
                </div>
              </div>
              <div style="display: flex; margin-top: 16px;">
                <p style="text-align: left; width: 250px;"><b>閲覧権限</b></p>
                <div style="width: calc(100% - 250px);">
                  <p style="text-align: left;"><b-switch size="is-small" v-model="cbInfo.is_permitted" :disabled="!isRoboEditPermission(cbInfo)"></b-switch>{{cbInfo.is_permitted ? '権限をON' : '権限をOFF'}}</p>
                  <div style="display: flex; align-items: flex-start; flex-wrap: wrap; overflow-y: scroll; margin-top: 8px;">
                    <b-checkbox v-for="(us, idx2) in showUsers" :key="idx2" style="margin: 5px;" v-model="permitList" :native-value="us.user_hash" :disabled="cbInfo.is_confirm || !isRoboEditPermission(cbInfo)">
                      {{us.username}}
                    </b-checkbox>
                  </div>
                  <button @click="sendControlLog('ロボ閲覧権限変更', ''); cbInfo.permit_users={'users': permitList}; $store.dispatch('chatbot/setChatBot', cbInfo)" style="margin-top: 8px;" class="button is-primary is-small is-fullwidth">権限設定を反映する</button>
                </div>
              </div>
              <div style="display: flex; margin-top: 16px;">
                <p style="text-align: left; width: 250px;"><b>ヘッダー項目</b></p>
                <div>
                  <b-radio v-model="cbInfo.bot_header_type"
                      name="header"
                      native-value = 0>
                      個別設定なし
                  </b-radio>
                  <b-radio v-model="cbInfo.bot_header_type"
                      name="header"
                      native-value = 1>
                      応募
                  </b-radio>
                  <b-radio v-model="cbInfo.bot_header_type"
                      name="header"
                      native-value = 2>
                      お問い合わせ
                  </b-radio>
                </div>
              </div>
              <div style="margin-top: 8px;">
                <p style="text-align: right; font-size: 12px;" v-if="cbInfo.bot_header_type == 1 || cbInfo.bot_header_type == 2">16文字以内</p>
                <div style="display: flex">
                  <p v-if="cbInfo.bot_header_type == 1 || cbInfo.bot_header_type == 2" style="text-align: left; width: 250px; margin-right: 16px;"><b>ヘッダー内文章</b></p>
                  <div style="width: calc(100% - 250px);">
                    <input placeholder="（例）お申し込みはこちら！" v-if="cbInfo.bot_header_type == 1" v-model="cbInfo.header_title" class="input" type="text" maxlength=16>
                    <input placeholder="（例）見学はこちら！" v-if="cbInfo.bot_header_type == 2" v-model="cbInfo.header_title" @input="headerTitleChange" class="input" type="text" maxlength=16>
                    <div style="text-align: left; margin-top: 8px; font-size: 12px" v-if="cbInfo.bot_header_type == 1 || cbInfo.bot_header_type == 2">
                      <p>表示する文言を変更することができます。</p>
                      <p v-if= "cbInfo.bot_header_type == 1">未入力の場合は、「ご応募はこちら！」と表示されます。</p>
                      <p v-if= "cbInfo.bot_header_type == 2">未入力の場合は、「お問い合わせはこちら！」と表示されます。</p>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex;">
                <p style="text-align: left; width: 250px;"></p>
                <div style="width: calc(100% - 250px);">
                  <button @click="headerTitleChange" style="margin-top: 8px;" class="button is-primary is-small is-fullwidth">ヘッダー設定を反映する</button>
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="ミニロボリスト" v-if="user.isAgent">
            <div style="padding: 24px;">
              <template v-if="cbInfo.chatbot_mini.length > 0">
                <div style="display: flex; margin: 8px;">
                  <input placeholder="ミニロボ名" class="input is-small" style="border-radius: 0;" v-model="minibotName"/>
                  <button style="min-width: 150px;" class="button is-primary is-small" @click="createChatBotMini(cbInfo)">ミニロボを作成する</button>
                </div>
                <div style="display: flex; margin: 8px;">
                  <input placeholder="変数名（先頭と末尾に$を付与してください）" class="input is-small" style="border-radius: 0;" v-model="minibotvarName"/>
                  <select class="select" style="height: 27px; border: 0; outline: 1px solid #ccc; outline-offset: -1px;" v-model="varTypeInput">
                    <option v-for="(t, idxType) in varType" :key="idxType" :value="idxType">
                      {{t}}
                    </option>
                  </select>
                  <button style="min-width: 150px;" class="button is-primary is-small" @click="createChatBotMiniVariableGroup(cbInfo)">共通変数を作成する</button>
                </div>
                <table style="overflow-y: scroll; will-change: transform;">
                  <tr style="display: table;">
                    <th style="vertical-align: middle; min-width: 64px; max-width: 64px;">項番</th>
                    <th style="vertical-align: middle; min-width: 70px; max-width: 70px;">アイコン</th>
                    <th style="vertical-align: middle; min-width: 120px; max-width: 120px;">名前</th>
                    <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">URL</th>
                    <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">配置設定</th>
                    <th style="vertical-align: middle; min-width: 90px; max-width: 90px;">プレビュー</th>
                    <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">リンク</th>
                    <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">保存</th>
                    <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">削除</th>
                  </tr>
                  <tr style="display: table; max-height: 50px; min-height: 50px; height: 50px;" v-for="(mini, index) in cbInfo.chatbot_mini" :key="index">
                    <td style="vertical-align: middle; min-width: 64px; max-width: 64px;">{{index + 1}}</td>
                    <td style="vertical-align: middle; min-width: 70px; max-width: 70px;" @mouseover="miniroboIconHover = index" @mouseleave="miniroboIconHover = -1">
                      <div style="position: relative;">
                        <img @click="modalActive(true, index)" style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" :src="mini.icon_data" v-if="mini.icon_data"/>
                        <img @click="modalActive(true, index)" style="cursor: pointer; width: 48px; height: 48px; border-radius: 50%; object-fit: cover; background: white;" src="@/assets/template/robot.png" v-else>
                        <div class="mini-delete-button" @click="deleteIcon(true, index)" v-if="miniroboIconHover===index">×</div>
                      </div>
                    </td>
                    <td style="vertical-align: middle; min-width: 120px; max-width: 120px;"><input class="input is-small" style="border: none; background: transparent;" v-model="mini.name"/></td>
                    <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                      <button class="button is-small is-primary" @click="isModalStartURL=true;setShowURL=mini.target_url">確認</button>
                    </td>
                    <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                      <button class="button is-small is-primary" @click="modalFooterUrl=mini">{{mini.target_url ? '起動中' : '待機中'}}</button>
                    </td>
                    <td style="vertical-align: middle; min-width: 90px; max-width: 90px;">
                      <a :href="makeLinkMini(cbInfo.scenario_name, mini)" target="_blank" rel="noopener" class="button is-primary is-small"><span class="mdi mdi-play"></span></a>
                    </td>
                    <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                      <button class="button is-small is-primary" @click="copySinglePageURLMini(cbInfo, mini)"><span class="mdi mdi-link-variant"></span></button>
                    </td>
                    <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                      <button class="button is-small is-primary" @click="updateChatBotMini(mini)">保存</button>
                    </td>
                    <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                      <button class="button is-small is-danger" @click="deleteChatBotMini(mini)">削除</button>
                    </td>
                  </tr>
                </table>
              </template>
              <template v-else>
                <img style="max-height: 200px;" src="@/assets/template/create_minibot.png"/>
                <p style="text-align: left; font-size: smaller;">
                  同じような応答をするロボを各施設毎、各メンバー毎の日程調整を<br/>
                  ロボ毎に作りたい時などにこちらのミニロボをご活用下さい。<br/>
                  共通変数を作成することで、同じ応答の中で、一部文言の変更や、<br/>
                  日程調整メンバー変更などが行えます。<br/>
                </p>
                <p style="text-align: left; color: red; font-size: smaller;">
                  ※本ロボが、既に設置済みであったり、求人ページに掲載している場合、<br/>
                  設置設定されているURLを初期化、公開設定も初期化しますので、<br/>
                  ご注意ください。<br/>
                </p>
                <button style="margin-top: 8px;" class="button is-primary is-fullwidth is-small" @click="isModalAddMiniBot=true">ミニロボを作成する</button>
              </template>
            </div>
          </b-tab-item>
          <b-tab-item label="共通変数一覧" v-if="user.isAgent">
            <div style="padding: 24px;">
              <template v-if="cbInfo.chatbot_mini.length > 0">
                <div style="display: flex; margin: 8px;">
                  <input placeholder="変数名（先頭と末尾に$を付与してください）" class="input is-small" style="border-radius: 0;" v-model="minibotvarName"/>
                  <select class="select" style="height: 27px; border: 0; outline: 1px solid #ccc; outline-offset: -1px;" v-model="varTypeInput">
                    <option v-for="(t, idxType) in varType" :key="idxType" :value="idxType">
                      {{t}}
                    </option>
                  </select>
                  <button style="min-width: 150px;" class="button is-primary is-small" @click="createChatBotMiniVariableGroup(cbInfo)">共通変数を作成する</button>
                </div>
                <template v-if="cbInfo.chatbot_mini[0].chatbot_mini_var.length > 0">
                  <table style="overflow-y: scroll; will-change: transform;">
                    <tr style="display: table;">
                      <th style="vertical-align: middle; min-width: 64px; max-width: 64px;">項番</th>
                      <th style="vertical-align: middle; min-width: 150px; max-width: 150px;">ロボ名</th>
                      <th style="vertical-align: middle; min-width: 120px; max-width: 120px;">変数</th>
                      <th style="vertical-align: middle; min-width: 120px; max-width: 120px;">タイプ</th>
                      <th style="vertical-align: middle; min-width: 120px; max-width: 120px;">データ</th>
                      <th style="vertical-align: middle; min-width: 80px; max-width: 80px;">保存</th>
                    </tr>
                    <template v-for="mini in cbInfo.chatbot_mini">
                      <tr style="display: table; max-height: 50px; min-height: 50px; height: 50px;" v-for="(mvar, index) in mini.chatbot_mini_var" :key="index">
                        <td style="vertical-align: middle; min-width: 64px; max-width: 64px;">{{index + 1}}</td>
                        <td style="vertical-align: middle; text-align: left; padding: 8px; min-width: 150px; max-width: 150px;">{{mini.name}}</td>
                        <td style="vertical-align: middle; text-align: left; padding: 8px; min-width: 120px; max-width: 120px;">{{mvar.variable_name}}</td>
                        <td style="vertical-align: middle; text-align: left; padding: 8px; min-width: 120px; max-width: 120px;">{{mvar.type === 0 ? '文言' : '日程調整'}}</td>
                        <td style="vertical-align: middle; text-align: left; padding: 8px; min-width: 120px; max-width: 120px;">
                          <template v-if="mvar.type === 0">
                            <input class="input is-small" style="border: none; background: transparent;" @change="updateChatBotMiniVariableGroup(mvar)" v-model="mvar.variable_data"/>
                          </template>
                          <template v-else>
                            <button class="button is-small is-fullwidth" @click="modalFooterVar=mvar">選択</button>
                          </template>
                        </td>
                        <td style="vertical-align: middle; min-width: 80px; max-width: 80px;">
                          <button class="button is-small is-primary" @click="updateChatBotMiniVariableGroup(mvar)">保存</button>
                        </td>
                      </tr>
                    </template>
                  </table>
                </template>
              </template>
              <template v-else>
                <img style="max-height: 200px;" src="@/assets/template/create_minibot.png"/>
                <p style="text-align: left; font-size: smaller;">
                  共通変数をお使いになる場合はミニロボが必要になります。<br/>
                  共通変数を作成することで、同じ応答の中で、一部文言の変更や、<br/>
                  日程調整メンバー変更などが行えます。<br/>
                </p>
                <p style="text-align: left; color: red; font-size: smaller;">
                  ※本ロボが、既に設置済みであったり、求人ページに掲載している場合、<br/>
                  設置設定されているURLを初期化、公開設定も初期化しますので、<br/>
                  ご注意ください。<br/>
                </p>
                <button style="margin-top: 8px;" class="button is-primary is-fullwidth is-small" @click="createChatBotMini(cbInfo)">ミニロボを作成する</button>
              </template>
            </div>
          </b-tab-item>
          <b-tab-item label="回答内容リスト">
            <div style="padding: 24px;">
              <div :class="{'display-none': botNameClick}" style="text-align: left">
                <article>
                  <h3 style="font-weight: bold; margin-bottom: 16px; border-bottom: 1px solid #dbdbdb; padding-bottom: 8px;">メインロボ</h3>
                  <template v-if="!cbInfoLoading">
                    <div style="margin-top: 8px; margin-left: 16px;">
                      <p @click="mainBotActionTable(cbInfo)" class="bot-name" style="font-size: 14px; cursor: pointer; width: fit-content">{{cbInfo.name}}</p>
                    </div>
                  </template>
                  <template v-else>
                    <div style="margin-top: 8px; margin-left: 16px;">
                      <p><span class="mdi mdi-loading mdi-spin" style="font-size: 14px;"></span></p>
                    </div>
                  </template>
                </article>
                <article style="margin-top: 32px">
                  <h3 style="font-weight: bold; margin-bottom: 16px; border-bottom: 1px solid #dbdbdb; padding-bottom: 8px;">ミニロボ一覧</h3>
                  <div class="mini-bots-wrapper">
                    <p v-if="cbInfo.chatbot_mini.length === 0 && !cbInfoLoading" style="font-size: 14px; margin-top: 8px; margin-left: 16px; color: rgb(187, 187, 187)">まだ作成されていません。</p>
                    <template v-if="!cbInfoLoading">
                      <div style="margin-top: 8px; margin-left: 16px;" v-for="(mini, index) in cbInfo.chatbot_mini" :key="index">
                        <p @click="miniBotActionTable(mini)" class="bot-name" style="font-size: 14px; cursor: pointer">{{mini.name}}</p>
                      </div>
                    </template>
                    <template  v-else>
                      <div style="margin-top: 8px; margin-left: 16px;">
                        <p><span class="mdi mdi-loading mdi-spin" style="font-size: 14px;"></span></p>
                      </div>
                    </template>
                  </div>
                </article>
              </div>
              <div :class="{'display-none': !botNameClick}" style="text-align: left; font-size: 12px;">
                <div @click="resetSeekerrSortedInfosState()"><i class="mdi mdi-arrow-left" style="font-size: 24px; cursor: pointer"></i></div>
                <div style="font-size: 14px;">{{selectBotName}}</div>
                <div class="list-container">
                  <p v-if="seekerIds.length === 0" style="font-size: 14px; color: rgb(187, 187, 187)">まだ回答者がいません。</p>
                  <div v-for="(seekerId, i) in seekerIds" :key="i" class="line">
                    <template v-for="seekerItem in seekerItems">
                      <div :key="seekerItem.seekerId"
                        class="seeker-item"
                        v-if="seekerItem.seekerId == seekerId"
                        style="background-color: #fff; padding: 8px; border-right: 1px transparent solid; margin-right: -1px; position: -webkit-sticky; position: sticky; left: 0;">
                        <div style="width: 200px;">
                          <p style="font-size: 14px;"><i class="mdi mdi-account" style="margin-right: 4px"></i>{{seekerItem.seekerName}}</p>
                          <p style="margin-top: 8px; font-size: 10px;">最終日時:{{seekerItem.latestDate}}</p>
                        </div>
                      </div>
                    </template>
                    <div v-for="(seekerSortedInfo, j) in seekerSortedInfos[seekerId]" :key="j" style="background-color: #fff; display: flex;">
                      <div>
                        <div class="item-box">
                          <div style="display: flex">
                            <p style="padding-right: 4px;"><span style="color: blue;">Q</span>:</p>
                            <p>{{alterReplace(seekerSortedInfo.cb_msg, true)}}</p>
                          </div>
                          <div style="display: flex; margin-top: 8px;">
                            <p style="padding-right: 4px"><span style="color: red;">A</span>:</p>
                            <p style="font-weight: bold;">{{alterReplace(seekerSortedInfo.seeker_msg, true)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
        <!-- モーダル　日程調整者選択 -->
        <div style="position: absolute; bottom: 0; right: 0; height: 45%; width: 100%; background: #f0f0f0; padding: 16px; z-index: 203; overflow-y: scroll;" v-if="modalFooterVar">
          <!-- 閉じる -->
          <button @click="modalFooterVar=null" class="button is-small" style="background: transparent; border: none; position: absolute; top: 8px; right: 8px;"><span class="mdi mdi-close mdi-24px"></span></button>
          <!-- タイトル -->
          <p style="text-align: left; font-weight: 600;"><span class="mdi mdi-note-plus-outline -right-8px"></span>日程調整メンバーを選択</p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
            必ず日程調整する際の予定を加えたい方を選択してください。<br/>
            シナリオ中の全日程調整に反映されます。
          </p>
          <div style="display: flex; flex-wrap: wrap; margin-top: 8px;">
            <b-checkbox v-for="(u, idx) in users" :key="idx" v-model="modalFooterVar.variable_user.users" style="margin: 5px;"
              :native-value="u.user_hash">
              {{u.username}}
            </b-checkbox>
            <button style="margin-top: 8px;" class="button is-small is-primary is-fullwidth" @click="updateChatBotMiniVariableGroup(modalFooterVar)">保存</button>
          </div>
        </div>
        <!-- モーダル　URL設定 -->
        <div style="position: absolute; bottom: 0; right: 0; height: 60%; width: 100%; background: #f0f0f0; padding: 16px; z-index: 203; overflow-y: scroll;" v-if="modalFooterUrl">
          <!-- 閉じる -->
          <button @click="modalFooterUrl=null" class="button is-small" style="background: transparent; border: none; position: absolute; top: 8px; right: 8px;"><span class="mdi mdi-close mdi-24px"></span></button>
          <!-- タイトル -->
          <p style="text-align: left; font-weight: 600;"><span class="mdi mdi-note-plus-outline -right-8px"></span>設置先URLを選択</p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
            設置先のURLをお選びください。
          </p>
          <div class="tabs" style="margin: 8px; overflow-x: auto; overflow-y: hidden;">
            <ul>
              <!-- 求人ページ -->
              <li>
                <a @click="tabIdx = -1;"
                  :style="{'color': tabIdx == -1 ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == -1 ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>求人ページ</b>
                </a>
              </li>
              <!-- カスタムページ -->
              <li>
                <a @click="tabIdx = -2;"
                  :style="{'color': tabIdx == -2 ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == -2 ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>カスタムページ</b>
                </a>
              </li>
              <!-- ホームページ -->
              <li v-for="(sitemapRoot, index) in sitemapRootList" :key="`X-${index}`">
                <a @click="tabIdx=index"
                  :style="{'color': index == tabIdx ? '#f0f0f0' : '#CC2C98', 'background': tabIdx == index ? '#CC2C98' : 'white'}"
                  style="color: white; border: solid thin #CC2C98; background: white; border-radius: 4px; padding: 4px 8px; margin: 0 8px;">
                  <b>{{sitemapRoot.root_url}}</b>
                </a>
              </li>
            </ul>
          </div>
          <div class="scroll-url" style="margin-top: 16px; padding-top: 8px; padding-left: 16px; margin-left: 8px; border: solid 2px #ccc; border-radius: 2px;">
            <!-- pagination -->
            <div style="margin-bottom: 16px;" v-if="tabIdx <= -1 && recruitList.length > 0">
              <b-pagination
                    style="background: #f0f0f0; border-radius: 8px; width: 95%;"
                    :total="contentsCount"
                    :current.sync="pages"
                    :per-page="30">
              </b-pagination>
            </div>
            <template v-if="tabIdx === -2">
              <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                <b-checkbox v-model="isAllSelectedCustom" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
              </p>
            </template>
            <template v-if="tabIdx === -1">
              <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                <b-checkbox v-model="isAllSelectedEmployment" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
              </p>
            </template>
            <template v-if="tabIdx >= 0">
              <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                <b-checkbox v-model="isAllSelectedHomePage" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
              </p>
            </template>
            <div style="position: relative;">
              <!-- ローディングページ -->
              <div class="init-page" style="background: transparent;" v-if="isContentsLoading">
                <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
              </div>
              <!-- 求人ページ -->
              <template v-for="(recruit, index) in sitemapRecruitList">
                <p class="url-list" v-if="tabIdx == -1 && recruit.contents.layout == 4 && !isAllUrl(tabIdx, 'ALL_RECRUIT_PAGES')"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="recruit">{{recruit.contents.content.title}}</b-checkbox>
                </p>
              </template>
              <!-- カスタムページ -->
              <template v-for="(custom, index) in sitemapCustomList">
                <p class="url-list" v-if="tabIdx == -2 && custom.contents.layout == 5 && !isAllUrl(tabIdx, 'ALL_RECRUIT_PAGES')"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="custom">{{custom.contents.title}}</b-checkbox>
                </p>
              </template>
              <!-- ホームページ -->
              <template v-for="(homepage, index) in sitemapRootList">
                <div v-if="tabIdx >= 0 && tabIdx === index && !isAllUrl(tabIdx, homepage)"
                  :key="`Z-${index}`"
                  style="text-align: left; vertical-align: middle;">
                  <template v-for="(node, index2) in homepage.node_list">
                    <p class="url-list" :key="index2">
                      <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="node">{{node.node_url}}</b-checkbox>
                    </p>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div style="margin-top: 8px;">
            <button class="button is-primary is-fullwidth" @click="isModalUrlSetMiniBot=true;isModalUrlSet=true">割り当てる</button>
            <div style="height: 5px;"></div>
            <button class="button is-primary is-fullwidth" @click="isModalUrlDeleteMiniBot=true;isModalUrlSet=true">起動URL解除</button>
          </div>
        </div>
      </div>
    </transition>
    <!-- Chatbot 詳細画面 end -->
    <transition name="fade">
      <div style="width: 100%; height: calc(100% - 100px); position: relative;" v-if="!$route.query.view">
        <!-- pagination -->
        <div style="padding: 16px; padding-left: 32px; padding-right: 32px; display: flex;" v-if="chatbots.length">
          <input class="input" style="width: 200px; margin-right: 10px;" placeholder="🔎ロボ名で検索" v-model="searchBotName"/>
          <div>
          <div class="tabs is-toggle is-small" style="margin-right: 10px;">
            <ul>
              <li :class="{'is-active': !archiveSwitch}">
                <a style="width: 128px; height: 36px;" @click="archiveSwitch=false"><span>一覧</span></a>
              </li>
              <li :class="{'is-active': archiveSwitch}">
                <a style="width: 128px; height: 36px;" @click="archiveSwitch=true"><span>アーカイブ</span></a>
              </li>
            </ul>
          </div>
          </div>
          <b-pagination
            style="width: calc(100% - 478px);"
            :total="nonArciveBots.length"
            :current.sync="chatbotsPages"
            :per-page="30">
          </b-pagination>
        </div>
        <div class="flex content-container-chatbot">
          <div style="display: flex; justify-content: center; align-items: flex-start; width: 100%; flex-wrap: wrap;" v-if="chatbots.length">
            <!-- 一覧 -->
            <draggable style="display: flex; justify-content: center; align-items: flex-start; flex-wrap: wrap; width: 100%;"
              :list="chatbots"
              @end="saveChatBotsOrder(chatbots)"
              :options="{animation: 300, group: { name: 'CHATBOTS', pull: 'clone', put: false}}">
              <!-- スタンダードプランではBot台数１０個まで -->
              <template v-for="(chatbot, index) in nonArciveBots">
                <div class="cb-card" 
                  :style="{'background': getSelectColor(chatbot)}"
                  :key="index" @mouseover="cbStatusHover=chatbot"
                  v-if="((index < chatbotsPages * 30 && index >= (chatbotsPages - 1) * 30 && !searchBotName) || (searchBotName && chatbot.name.indexOf(searchBotName) >= 0)) && !archiveSwitch && !chatbot.is_archive && isRoboDisplayPermission(chatbot)">
                  <div style="width: 7px; height: 80px; background: #AA0066; border-radius: 2.5px; margin-left: -20px; margin-right: 15px;" v-if="isOnBot(chatbot)"></div>
                  <div style="width: 7px; height: 80px; background: #BBB; border-radius: 2.5px; margin-left: -20px; margin-right: 15px;" v-if="!isOnBot(chatbot)"></div>
                  <b-checkbox v-model="selectedGroup" :native-value="chatbot"></b-checkbox>
                  <figure class="img-icon">
                    <img :src="chatbot.icon_data" v-if="chatbot.icon_data&&!isIconLoading">
                    <img src="@/assets/template/robot.png" v-if="!chatbot.icon_data&&!isIconLoading">
                  </figure>
                  <b-tooltip type="is-dark" label="詳細を見る" style="cursor: pointer; text-align: left; max-width: 32.5%; min-width: 32.5%; width: 32.5%; word-break: break-word;">
                    <div @click="showInfoView(chatbot, index)">
                      <p style="font-size: smaller;">{{ chatbot.name }}</p>
                      <a><span class="mdi mdi-square-edit-outline" style="color: #666; font-size: x-small;">詳細を開く</span></a>
                      <star-rating style="font-size: smaller; margin-top: 0; color: yellow;" :read-only="true" :increment="0.01" :rating="getScoreCB(chatbot)" :star-size="15" :show-rating="false"></star-rating>
                      <p><span class="mdi mdi-shopping" style="color: #666; font-size: x-small;" v-if="chatbot.is_store">ストアからダウンロード</span></p>
                    </div>
                  </b-tooltip>
                  <div>
                    <p style="font-size: x-small;" v-if="chatbot.chatbot_mini.length >= 1">ミニロボ</p>
                    <div style="padding: 10px 10px; background: #D7F87E; font-size: smaller;" v-if="isOnBot(chatbot)">起動中</div>
                    <div style="padding: 10px 10px; background: #BBB; color: white; font-size: smaller;" v-else>待機中</div>
                  </div>
                  <div style="width: 160px; height: 60px; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; margin-top: -25px;">
                    <b-tooltip type="is-dark" label="起動設定" style="margin: 5px 5px;" v-if="chatbot.chatbot_mini.length < 1">
                      <a @click="selectedGroup=[chatbot];groupSelectStep=1" class="button menu-btn" :disabled="chatbot.chatbot_mini.length >= 1"><span class="mdi mdi-power mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="起動設定はミニロボのみ行えます" style="margin: 5px 5px;" v-else>
                      <a class="button menu-btn" :disabled="chatbot.chatbot_mini.length >= 1"><span class="mdi mdi-power mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="シナリオ編集画面へ" style="margin: 5px 5px;">
                      <a @click="setScenarioName(chatbot.scenario_name, chatbot)" class="button menu-btn" :disabled="!isRoboEditPermission(chatbot)"><span class="mdi mdi-tooltip-edit mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="プレビューデモ" style="margin: 5px 5px;">
                      <a :href="makeLink(chatbot.scenario_name)" target="_blank" rel="noopener" class="button menu-btn" :disabled="!isRoboEditPermission(chatbot)"><span class="mdi mdi-play mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="シェアリンクの取得" style="margin: 5px 5px;">
                      <a @click="copySinglePageURL(chatbot)" class="button menu-btn"><span class="mdi mdi-link-variant mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="会話履歴のダウンロード" style="margin: 5px 5px;">
                      <a @click="downloadDialog([chatbot])" class="button menu-btn"><span class="mdi mdi-download mdi-16px"></span></a>
                    </b-tooltip>
                    <b-tooltip type="is-dark" label="削除" style="margin: 5px 5px;">
                      <a @click="deleteChatBot(chatbot.bot_id)" class="button menu-btn" :disabled="!isRoboEditPermission(chatbot)"><span class="mdi mdi-delete mdi-16px"></span></a>
                    </b-tooltip>
                  </div>
                </div>
              </template>
              <div style="display:flex; width:49%; height: 100px;" v-if="chatbots.length%2 != 0"></div>
            </draggable>
            <!-- アーカイブ -->
            <draggable style="display: flex; justify-content: center; align-items: flex-start; flex-wrap: wrap; width: 100%;" :list="chatbots" @end="saveChatBotsOrder(chatbots)" :options="{animation: 300, group: { name: 'CHATBOTS', pull: 'clone', put: false}}">
              <!-- スタンダードプランではBot台数１０個まで -->
              <template v-for="(chatbot, index) in chatbots">
                <div class="cb-card"
                :style="{'background': getSelectColor(chatbot)}"
                :key="index" @mouseover="cbStatusHover=chatbot"
                v-if="archiveSwitch&&chatbot.is_archive">
                  <div style="width: 7px; height: 80px; background: #AA0066; border-radius: 2.5px; margin-left: -20px; margin-right: 15px;" v-if="chatbot.target_url !== ''"></div>
                  <div style="width: 7px; height: 80px; background: #BBB; border-radius: 2.5px; margin-left: -20px; margin-right: 15px;" v-if="chatbot.target_url === ''"></div>
                  <!-- <b-checkbox v-model="selectedGroup" :native-value="chatbot"></b-checkbox> -->
                  <figure class="img-icon">
                    <img :src="chatbot.icon_data" v-if="chatbot.icon_data&&!isIconLoading">
                    <img src="@/assets/template/robot.png" v-if="!chatbot.icon_data&&!isIconLoading">
                  </figure>
                  <b-tooltip type="is-dark" label="詳細を見る" style="cursor: pointer; text-align: left; max-width: 32.5%; min-width: 32.5%; width: 32.5%; word-break: break-word;">
                    <div @click="showInfoView(chatbot, index)">
                      <p style="font-size: smaller;">{{ chatbot.name }}</p>
                      <a><span class="mdi mdi-square-edit-outline" style="color: #666; font-size: x-small;">詳細を開く</span></a>
                      <star-rating style="font-size: smaller; margin-top: 0; color: yellow;" :read-only="true" :increment="0.01" :rating="getScoreCB(chatbot)" :star-size="15" :show-rating="false"></star-rating>
                      <p><span class="mdi mdi-shopping" style="color: #666; font-size: x-small;" v-if="chatbot.is_store">ストアからダウンロード</span></p>
                    </div>
                  </b-tooltip>
                  <div>
                    <p style="font-size: x-small;" v-if="chatbot.chatbot_mini.length >= 1">ミニロボ</p>
                    <div style="padding: 10px 10px; background: #D7F87E; font-size: smaller;" v-if="isOnBot(chatbot)">起動中</div>
                    <div style="padding: 10px 10px; background: #BBB; color: white; font-size: smaller;" v-else>待機中</div>
                  </div>
                  <div style="width: 160px; height: 60px; display: flex; justify-content: center; align-items: center; flex-direction: column; margin-top: 16px;">
                      <a @click="selectedGroup=[chatbot];changeArchive(false)" class="button is-small" style="width: 150px; margin: 8px;" :disabled="!isRoboEditPermission(chatbot)">元に戻す</a>
                      <a @click="deleteChatBot(chatbot.bot_id)" class="button is-small is-danger" style="width: 150px; margin: 8px;" :disabled="!isRoboEditPermission(chatbot)">削除する</a>
                  </div>
                </div>
              </template>
              <div style="display:flex; width:49%; height: 100px;" v-if="chatbots.length%2 != 0"></div>
            </draggable>
            <!-- Chatbot モーダルコンポーネント -->
            <ModalCreateChatBot ref="create"/> <ModalDeleteChatBot :deleteIndex="deleteIndex" ref="delete" :PCTRLLOG="CTRLLOG"/> <ModalEditChatBot :editIndex="editIndex" :originalChatBot="originalChatBot" ref="edit"/>
          </div>
          <!-- ローディング＋ゼロ件の場合 -->
          <div style="display: flex; justify-content:center; align-items:center; height: 100%; width: 100%;" v-else>
            <div class="load-display" v-if="isCBLoading">
              <p><img src="@/assets/template/nowactivating.svg"></p>
              <p><img src="@/assets/template/robot_animated.svg"></p>
            </div>
            <div style="padding: 10px;" v-if="!chatbots.length&&!isCBLoading">
              <div class="init-message">
                <p>ロボ倉庫へようこそ！</p>
                <p>+ボタンからロボを作成してみましょう。</p>
              </div>
              <b-tooltip label="新しいロボを作成する" position="is-bottom">
                <div class="card create-card">
                  <div class="card-content">
                    <div class="content">
                      <a @click="createChatBot()">
                        <span class="mdi mdi-plus mdi-48px"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </b-tooltip>
            </div>
            <ModalCreateChatBot ref="create"/>
          </div>
          <!-- フッター チェックボックス用 -->
          <!-- Footer -->
          <div class="select-footer" :style="{'height': groupSelectStep + (200*(groupSelectStep+1)) + 'px'}" v-if="selectedGroup.length > 0">
            <img style="width: 80px; height: 80px; background: white; border-radius: 50%; margin-left: 20px;" src="@/assets/lp/hrmonster.png" />
            <div class="message-box" :style="{'height': groupSelectStep + (150*(groupSelectStep+1)) + 'px'}" v-if="groupSelectStep == 0">
              <p style="margin-bottom: 8px;">{{selectedGroup.length}}体選択中です！ 下記のコマンドを実行できますが、どうしますか？</p>
              <p style="margin-bottom: 8px; font-size: x-small;" v-if="hasMiniBot(selectedGroup)">ミニロボを含むロボを選択している場合、起動URLの割り当ておよび解除は行えません。</p>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" v-if="!hasMiniBot(selectedGroup)" @click="groupSelectStep=1">起動URLを割り当てる</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" v-if="!hasMiniBot(selectedGroup)" @click="isModalUrlDeleteBot=true;isModalUrlSet=true">起動URLを解除する</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="downloadDialog(selectedGroup)">会話履歴をダウンロードする</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="setRecruitPage(true)">HRM求人媒体へ公開</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="setRecruitPage(false)">HRM求人媒体へ非公開</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="exportBot(selectedGroup[0])" v-if="selectedGroup.length == 1 || !isRoboEditPermission(selectedGroup[0])">ロボをエクスポートする</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="changeArchive(true)">アーカイブする</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsDelete()">削除する</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsAll(true)">全選択する</button>
              <button class="button" style="margin-right: 8px; margin-bottom: 8px; background: rgba(0, 0, 0, 0.4); color: white; font-size: smaller;" @click="selectsAll(false)">キャンセル</button>
            </div>
            <div class="message-box" :style="{'height': groupSelectStep + (195*(groupSelectStep+1)) + 'px'}" v-if="groupSelectStep == 1">
              <p style="margin-bottom: 8px;">{{selectedGroup.length}}体に対して設定します！どのURLを割り当てますか？</p>
              <div class="tabs" style="margin: 0; overflow-x: scroll; overflow-y: hidden;">
                <ul>
                  <li>
                    <a style="color: white; border: solid thin #fff; background: #222; border-radius: 4px; padding: 4px 8px; margin: 0 8px;" :style="{'color': tabIdx == -1 ? '#CC2C98' : 'white', 'background': tabIdx == -1 ? '#f0f0f0' : '#222'}" @click="tabIdx=-1;isRecruitPage=true"><b>求人ページ</b></a>
                  </li>
                  <li>
                    <a style="color: white; border: solid thin #fff; background: #222; border-radius: 4px; padding: 4px 8px; margin: 0 8px;" :style="{'color': tabIdx == -2 ? '#CC2C98' : 'white', 'background': tabIdx == -2 ? '#f0f0f0' : '#222'}" @click="tabIdx=-2;isRecruitPage=false"><b>カスタムページ</b></a>
                  </li>
                  <li v-for="(s, index) in sitemapRootList" :key="`X-${index}`">
                    <a style="color: white; border: solid thin #fff; background: #222; border-radius: 4px; padding: 4px 8px; margin: 0 8px;" :style="{'color': index == tabIdx ? '#CC2C98' : 'white', 'background': tabIdx == index ? '#f0f0f0' : '#222'}" @click="tabIdx=index"><b>{{s.root_url}}</b></a>
                  </li>
                </ul>
              </div>
              <div class="scroll-url" style="margin-top: 16px; padding-top: 8px; padding-left: 16px; margin-left: 8px; border: solid 2px #ccc; border-radius: 2px;">
                <!-- pagination -->
                <div style="margin-bottom: 16px;" v-if="(tabIdx === -1 && sitemapCustomList.length > 0) || (tabIdx === -2 && sitemapCustomList.length > 0)">
                  <b-pagination
                        style="background: #f0f0f0; border-radius: 8px; width: 95%;"
                        :total="contentsCount"
                        :current.sync="pages"
                        :per-page="30">
                  </b-pagination>
                </div>
                <template v-if="tabIdx === -2">
                  <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                    <b-checkbox v-model="isAllSelectedCustom" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
                  </p>
                </template>
                <template v-if="tabIdx === -1">
                  <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                    <b-checkbox v-model="isAllSelectedEmployment" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
                  </p>
                </template>
                <template v-if="tabIdx >= 0">
                  <p style="text-align: left; vertical-align: middle; display: flex; align-items: center; margin-bottom: 16px;">
                    <b-checkbox v-model="isAllSelectedHomePage" @input="getAllUrl(tabIdx)"><b>全URLに適用する</b></b-checkbox>
                  </p>
                </template>
                <div style="position: relative;">
                  <!-- ローディングページ -->
                  <div class="init-page" v-if="isContentsLoading">
                    <span class="mdi mdi-spin mdi-loading mdi-48px"></span>
                  </div>
                  <!-- 求人ページ -->
                  <template v-for="(recruit, index) in sitemapRecruitList">
                    <p class="url-list" v-if="tabIdx == -1 && recruit.contents.layout == 4 && !isAllUrl(tabIdx, 'ALL_RECRUIT_PAGES')"
                      :key="`Z-${index}`"
                      style="text-align: left; vertical-align: middle;">
                      <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="recruit">{{recruit.contents.content.title}}</b-checkbox>
                    </p>
                  </template>
                  <!-- カスタムページ -->
                  <template v-for="(custom, index) in sitemapCustomList">
                    <p class="url-list" v-if="tabIdx == -2 && custom.contents.layout == 5 && !isAllUrl(tabIdx, 'ALL_RECRUIT_PAGES')"
                      :key="`Z-${index}`"
                      style="text-align: left; vertical-align: middle;">
                      <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="custom">{{custom.contents.title}}</b-checkbox>
                    </p>
                  </template>
                  <!-- ホームページ -->
                  <template v-for="(homepage, index) in sitemapRootList">
                    <div v-if="tabIdx >= 0 && tabIdx === index && !isAllUrl(tabIdx, homepage)"
                      :key="`Z-${index}`"
                      style="text-align: left; vertical-align: middle;">
                      <template v-for="(node, index2) in homepage.node_list">
                        <p class="url-list" :key="index2">
                          <b-checkbox style="white-space: nowrap;" v-model="selectSitemapList" :native-value="node">{{node.node_url}}</b-checkbox>
                        </p>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
              <div style="margin-top: 8px;">
                <button class="button is-primary" @click="isModalUrlSetBot=true;isModalUrlSet=true">割り当てる</button>
                <button style="margin-left: 16px;" class="button" @click="groupSelectStep=0;selectedGroup=[];urlList=[];">キャンセル</button>
              </div>
            </div>
          </div>
        </div>
        <ModalDownloadTalkHistory ref="talkDownload"/>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="$route.query.view === 'sitemap'" class="flex content-container-scenario">
        <Sitemap @changeScnList="setScenarioName" @getSitemapRoboList="getSitemapRoboList"/>
      </div>
    </transition>
    <transition name="fade">
      <!-- シナリオ名一覧を表示し、クリックされたシナリオの中身を一覧で表示する -->
      <div v-if="$route.query.view === 'scenario'" class="flex content-container-scenario">
        <div class="scenario-content">
          <aside class="menu menu-box">
            <!-- シナリオ一覧 -->
            <p class="title-menu">
              <span class="mdi mdi-comment-text-multiple mdi-24px" style="margin-right: 10px;"></span><b>一覧</b>
            </p>
            <ul class="menu-list">
              <template v-for="(c, index) in chatbots">
                <span :key="index" v-if="!c.is_archive && isRoboEditPermission(c)">
                  <li :class="{'active-menu': c.scenario_name === selectScenarioName}">
                    <a class="menu-button" @click="setScenarioName(c.scenario_name, c);">
                      <template v-if="c.scenario_name === selectScenarioName && scenarioTitleBeforeChange != ''">{{ scenarioTitleBeforeChange }}</template>
                      <template v-if="c.is_confirm">
                        <p style="font-weight: bold;">{{ c.name }}</p>
                      </template>
                      <template v-else>
                        <p>{{ c.name }}</p>
                      </template>
                    </a>
                  </li>
                </span>
              </template>
            </ul>
          </aside>
          <ScenarioList @back="changeList" v-if="selectScenario !== ''" :openSettingNameModal="showInfoView" :PCTRLLOG="CTRLLOG"/>
          <div v-if="selectScenario === ''" class="scenario-content" style="display: flex; justify-content: center;">
            <div style="margin: 10%;" v-if="isSCNLoading">
              <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div v-if="isDetailHover" class="scenario-content-balloon">
            <div style="text-align: left; padding: 15px;">
              <p style="font-size: 18px; border-bottom: solid 2px #ccc;"><b>{{detailScnName}} を使用しているロボ一覧</b></p>
              <div class="columns is-multiline is-mobile" style="justify-content: center; overflow: hidden; margin-top: 10px;">
                <span v-for="(chatbot, index) in chatbots" :key="index">
                  <div style="padding: 10px;" v-if="chatbot.scenario_name === detailScnName">
                    <div class="card" style="border-radius: 5px; max-width: 150px; min-width: 150px;">
                      <div slot="trigger" class="card-header">
                        <p class="card-header-title" style="padding-right: 10px;">
                          <span style="color: greenyellow; padding-right: 10px;" class="mdi mdi-checkbox-blank-circle" v-if="chatbot.target_url !== ''"></span>
                          <span style="padding-right: 10px;" class="mdi mdi-checkbox-blank-circle-outline" v-if="chatbot.target_url === ''"></span>
                          <span>{{ chatbot.name }}</span>
                        </p>
                      </div>
                      <div class="card-content">
                        <figure class="img-icon">
                          <img :src="chatbot.icon_data" v-if="chatbot.icon_data&&!isIconLoading">
                          <img src="@/assets/template/robot.png" v-if="!chatbot.icon_data&&!isIconLoading">
                        </figure>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </transition>
        <!-- 設定メニュー -->
        <div class="setting-content">
          <div>
            <!-- header -->
            <div class="header-setting">
              <!-- パーツ -->
              <div>
                <b-tooltip label="シナリオパーツ" position="is-left" type="is-dark">
                  <a @click="isParts=true;isTemplate=false;isChatbotInfo=false">
                    <span class="mdi mdi-expand-all mdi-36px" :style="{'color': activeTab(isParts)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <!-- パーツセット -->
              <div>
                <b-tooltip label="パーツセット" position="is-left" type="is-dark">
                  <a @click="isParts=false;isTemplate=true;isChatbotInfo=false" v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                    <span class="mdi mdi-bulletin-board mdi-36px" :style="{'color': activeTab(isTemplate)}"></span>
                  </a>
                  <a v-if="selectChatbot.is_confirm || isRoboPartsSetView" style="cursor: not-allowed; color: #E9BDB5;">
                    <span class="mdi mdi-bulletin-board mdi-36px" :style="{'color': activeTab(isTemplate)}"></span>
                  </a>
                </b-tooltip>
              </div>
              <!-- ロボ詳細 -->
              <div>
                <b-tooltip label="ロボ詳細" position="is-left" type="is-dark">
                  <a @click="showInfoView(selectChatbot)">
                    <span class="mdi mdi-robot mdi-36px"></span>
                  </a>
                </b-tooltip>
              </div>
            </div>
            <!-- body -->
            <div class="body-setting">
              <ScenarioParts :isParts="isParts" :roboLock="selectChatbot.is_confirm" :scenarioTable="scenarioTable" @dragScenarioParts="dragScenarioParts" @resetDrag="resetDrag"/>
              <div v-if="isTemplate">
                <!-- パーツセット新規作成 -->
                <div v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                  <a @click="isCreateRoboPartsSetModal=true">
                    <span class="mdi mdi-bulletin-board mdi-12px">パーツセット新規作成</span>
                  </a>
                </div>
                <div v-else>
                  <a>
                    <span class="mdi mdi-bulletin-board mdi-12px" style="cursor: not-allowed; color: #E9BDB5;">パーツセット新規作成</span>
                  </a>
                </div>
                <div v-if="roboPartsSet.length === 0">
                  <span class="mdi mdi-file-outline mdi-48px"></span>
                  <p style="padding: 10px;">パーツセットが<br>存在しません。</p>
                </div>
                <div v-if="!selectChatbot.is_confirm && !isRoboPartsSetView">
                  <div class="card body-setting-template" v-for="(set, index) in roboPartsSet" :key="index" draggable="true" @dragstart="dragRoboPartsSet(set)" @dragend="resetDrag()">
                    <header class="card-header">
                      <p class="card-header-title">
                        {{ set.robo_parts_set_name }}
                      </p>
                    </header>
                    <div class="card-content">
                      <p>パーツ数： {{set.scenario_list.length}}</p>
                      <p>作成者： {{set.author}}</p>
                    </div>
                    <footer class="card-footer">
                      <a class="card-footer-item" @click="dispRoboPartsSetView(set)" style="padding: 5px;"><span class="mdi mdi-view-quilt mdi-24px" style="margin-right: 5px;"></span>パーツセット編集</a>
                    </footer>
                  </div>
                </div>
                <div v-else>
                  <div class="card body-setting-template" v-for="(set, index) in roboPartsSet" :key="index">
                    <header class="card-header" style="cursor: not-allowed; color: #E9BDB5;">
                      <p class="card-header-title" style="cursor: not-allowed; color: #E9BDB5;">
                        {{ set.robo_parts_set_name }}
                      </p>
                    </header>
                    <div class="card-content" style="cursor: not-allowed; color: #E9BDB5;">
                      <p>パーツ数： {{set.scenario_list ? set.scenario_list.length : 0}}</p>
                      <p>作成者： {{set.author}}</p>
                    </div>
                    <footer class="card-footer" style="cursor: not-allowed; color: #E9BDB5;">
                      <a class="card-footer-item" style="padding: 5px; cursor: not-allowed; color: #E9BDB5;">
                        <span class="mdi mdi-view-quilt mdi-24px" style="margin-right: 5px;"></span>
                        パーツセット編集
                      </a>
                    </footer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <input type="hidden" style="opacity: 0 !important;" id="copy_code" :value="singleURL"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import ScenarioList from '@/views/DashBoard/ChatBot/ScenarioList'
import Sitemap from '@/views/DashBoard/ChatBot/Sitemap'
import ScenarioParts from '@/views/DashBoard/ChatBot/ScenarioParts'
import ModalCreateChatBot from '@/components/ui/ModalCreateChatBot'
import ModalDeleteChatBot from '@/components/ui/ModalDeleteChatBot'
import ModalEditChatBot from '@/components/ui/ModalEditChatBot'
import ModalStoreUpload from '@/components/ui/ModalStoreUpload'
import StarRating from 'vue-star-rating'
import Cropper from "./Cropperjsicon"
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import ModalDownloadTalkHistory from '@/components/ui/ModalDownloadTalkHistory'
import alterReplace from '@/functions/alterStrReplace'
import {
  SITEMAP_OVERALL
} from '@/functions/users/sitemapFunc'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import controlLogMixin from '@/mixins/controlLogMixin'
import {
  isRoboEditPermission,
  isRoboDisplayPermission
} from '@/functions/checkPermission'

export default {
  name: 'ChatBotList',
  componentName: 'ChatBotList',
  components: {
    ScenarioList,
    ModalCreateChatBot,
    ModalDeleteChatBot,
    ModalEditChatBot,
    ModalStoreUpload,
    Sitemap,
    draggable,
    StarRating,
    Cropper,
    ModalSelectMedia,
    ModalDownloadTalkHistory,
    ScenarioParts,
    alterReplace,
    Tooltip
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('employmentPage', ['contents', 'cntCompanyCount', 'isContentsLoading']),
    ...mapState('directtalk', ['csvFile', 'seekerInputInfos', 'cbInfoLoading']),
    ...mapState('chatbot', ['chatbots', 'selectChatbot', 'selectScenario', 'isSCNLoading', 'isDrop', 'scenarioTable', 'isIconLoading', 'isCBLoading', 'isFailedScenario', 'chatbotStatus', 'roboPartsSet', 'dropTemplate', 'selectChatbot', 'selectScenarioName', 'scenarioTitleBeforeChange', 'roboPartsSet', 'isRoboPartsSetView']),
    ...mapState('auth', ['user','query_url_chat', 'users', 'query_url_direct']),
    ...mapState('employmentPage', ['contents']),
    ...mapState('mediapool', ['images']),
    ...mapState('sitemap',['sitemapRecruitList', 'sitemapCustomList', 'sitemapRootList', 'countRecruitPage', 'countCustomPage', 'sitemapRecruitListAll', 'sitemapCustomListAll']),
    nonArciveBots () {
      let bots = []
      for (let cb of this.chatbots) if (!cb.is_archive) bots.push(cb)
      return bots
    },
    showUsers () {
        // ログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
  data () {
    return {
      COMPONENT_NAME: 'ChatBotList',
      activeTabInfo: 0,
      isMini: false,
      miniIdx: 0,
      minibotName: null,
      minibotvarName: null,
      modalFooterVar: null,
      modalFooterUrl: null,
      varType: [
        '文言',
        '日程調整',
      ],
      varTypeInput: 0,
      botInfoPage: 0,
      permitList: [],
      archiveSwitch: false,
      pages: 1,
      chatbotsPages: 1,
      selectSitemapList: [],
      urlList: [],
      recruitList: [],
      isOK: false,
      photo: '',
      setShowURL: '',
      isAdd: false,
      addName: '',
      singleURL: '',
      originalChatBot: null,
      deleteIndex: -1,
      editIndex: -1,
      isMenuOpen: false,
      isChatbotList: true,
      isScenarioList: false,
      isSitemap: false,
      isShowStatus: false,
      isParts: true,
      isTemplate: false,
      isTemplateBot: false,
      isStore: false,
      isChatbotInfo: false,
      isChatbotStore: false,
      isEditName: false,
      isOpenScenarioMenu: false,
      isModalStartURL: false,
      isModalAddMiniBot: false,
      isModalUrlSet: false,
      isModalUrlSetBot: false,
      isModalUrlSetMiniBot: false,
      isModalUrlDeleteBot: false,
      isModalUrlDeleteMiniBot: false,
      uploadedImage: null,
      filename: '',
      searchBotName: null,
      counter:0,
      selectedGroup: [],
      groupSelectStep: 0,
      tabIdx: 0,
      cb: null,
      cbInfo: {
        name: '',
        icon: '',
        target_url: '',
        scenario_name: '',
        created_at: '2019/4/1',
        parameter: {
          category: []
        }
      },
      cbInfoIndex: null,
      categories: [
        {
          name: 'デフォルト',
          id: 'default'
        },
        {
          name: '使用回数順',
          id: 'used'
        },
        {
          name: '返信数順',
          id: 'reply'
        }
      ],
      categoriesTags: [
        {
          idx: 0,
          name: 'ニュース・トピック',
        },
        {
          idx: 1,
          name: '相談（匿名可）',
        },
        {
          idx: 2,
          name: '手続き',
        },
        {
          idx: 3,
          name: '情報案内',
        }
      ],
      categoriesStore: [
        'スターター',
        'プレミアム',
        'Q&A',
        '応募',
        '営業',
        'お問い合わせ',
        'その他',
      ],
      storeItemName: '',
      storeItemCategory: '',
      storeItemDetail: '',
      cbStatusHover: {
        name: '',
        target_url: ''
      },
      selectedCategory: null,
      isDetailHover: false,
      isRecruitPage: true,
      isDetailName: '',
      inputs: {
        mainmessage: '',
        status: 0, // 0 => 選択肢, 1 => 応募, 2 => メッセージのみ, 3 => ロボ切替
        beforenode: '',
        beforenodeX: 50,
        beforenodeY: 50,
        start_flg: true,
        select: [
          {
            message: '',
            next_node: '',
            text_option: 'white',
            msg_type: 'button'
          },
          {
            message: '',
            next_node: '',
            text_option: 'white',
            msg_type: 'button'
          },
          {
            message: '',
            next_node: '',
            text_option: 'white',
            msg_type: 'button'
          }
        ]
      },
      botNameClick: false,
      seekerIds: [],
      seekerSortedInfos: {},
      selectBotName: '',
      seekerItems: [],
      seekerSortedActions: [],
      isAllSelectedEmployment: false,
      isAllSelectedCustom: false,
      isAllSelectedHomePage: false,
      pageData: {
        pages  : SITEMAP_OVERALL.PAGES,
        per_page: SITEMAP_OVERALL.PER_PAGE,
        content_type: 0
      },
      contentsCount: 0,
      recruitPages : 1,
      customPages  : 1,
      roboIconHover: false,
      miniroboIconHover: false,
      planLimit: '１０台',
      isCreateRoboPartsSetModal: false,
      roboPartsSetName: null,
      author: null,
      scenario: [],
      allPartsConfirm: false,
    }
  },
  mounted (){
    this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
    this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.$route.query.scenario })
    if (this.query_url_chat == null){
      //処理をしない
    } else {
      for (var key in this.chatbots) {
          if (this.chatbots[key].name == this.query_url_chat) {
            this.showInfoView(this.chatbots[key],key)
          }
      }
      this.$store.dispatch('auth/getQueryDelet','chat')
    }
    if (this.$route.query.pages && !this.$route.query.view) {
      if (this.$route.query.pages >= 1) {
        this.pages = Number(this.$route.query.pages)
        if (this.$route.query.pages) {
          if (this.$route.query.pages >= 1) {
            if (this.tabIdx === -1) {
              const pageData = {
                pages  : this.pages,
                per_page: 30,
                content_type: 4
              }
              this.$store.dispatch('sitemap/getSitemapRecruitList', pageData)
            } else if (this.tabIdx === -2) {
              const pageData = {
                pages  : this.pages,
                per_page: 30,
                content_type: 5
              }
            this.$store.dispatch('sitemap/getSitemapCustomList', pageData)
            }
            this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
            this.$router.push('/dashboard/chatbot?pages=' + this.pages + '&recruit=' + this.isRecruitPage)
          }
        }
        this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
        this.$store.dispatch('sitemap/getSitemapRecruitListAll')
        this.$store.dispatch('sitemap/getSitemapCustomListAll')
      }
    } else if (!this.$route.query.view) {
      this.$router.push('/dashboard/chatbot?pages=' + this.pages + '&recruit=' + this.isRecruitPage)
    }
    if  (this.query_url_direct == null){
          //処理をしない
    }else{
      this.getallroom(this.query_url_direct)
      this.$store.dispatch('auth/getQueryDelet','direct')
    }
  },
  methods: {
    isPlan (mode) {
      var confirmCount = 0
      for (var c of this.chatbots) {
        if (c.is_confirm) {
          confirmCount += 1
        }
      }
      if (mode === 'plan') {
        if (this.user.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
          // 介護NEXT様用
          this.planLimit = '２０台'
          if (confirmCount >= 20 && this.user.billing === 1) {
            return true
          } else {
            return false
          }
        } else {
          this.planLimit = '１０台'
          if (confirmCount >= 10 && this.user.billing === 1) {
            return true
          } else {
            return false
          }
        }
      } else if (mode === 'limit') {
        if (this.user.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
          // 介護NEXT様用
          if (confirmCount < 20 || this.user.billing !== 1) {
            return true
          } else {
            return false
          }
        } else {
          if (confirmCount < 10 || this.user.billing !== 1) {
            return true
          } else {
            return false
          }
        }
      }
    },
    createChatBotMini (chatbot) {
      this.sendControlLogRelatedChatBot('ミニロボ作成', '', chatbot)
      let name = null
      if (this.minibotName) {
        name = this.minibotName
      } else {
        name = chatbot.name + Number(chatbot.chatbot_mini.length+1)
      }
      let createChatBotMiniTemp = {
        name            : name,
        chatbot         : chatbot.bot_id,
        target_url      : null,
        start_url       : null,
        working_hours   : chatbot.working_hours,
        is_recruit      : false,
        is_permitted    : false,
        permit_users    : null,
        send_power      : 0,
        select_power    : 0,
        receive_power   : 0,
        subscribe_power : 0
      }
      this.$store.dispatch('chatbot/createChatBotMini', createChatBotMiniTemp)
        .then((data) => {
          this.cbInfo.chatbot_mini.push(data)
          this.cbInfo.chatbot_mini = Array.from(new Map(this.cbInfo.chatbot_mini.map(obj => [obj.bot_id, obj])).values())
        })
      this.updateChatBotDeleteURL(chatbot)
      this.minibotName = null
    },
    updateChatBotMini (chatbotmini) {
      this.sendControlLogRelatedChatBot('ミニロボ名変更', '',this.cbInfo)
      let updateChatBotMiniTemp = chatbotmini
      this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
    },
    updateChatBotDeleteURL (cb) {
      let cbTemp = cb
      cbTemp.target_url = ''
      cbTemp.start_url = ''
      cbTemp.is_recruit = false
      this.$store.dispatch('chatbot/setChatBot', cbTemp)
    },
    deleteChatBotMini (chatbotmini) {
      this.sendControlLogRelatedChatBot('ミニロボ削除', '', this.cbInfo)
      this.$store.dispatch('chatbot/deleteChatBotMini', chatbotmini.pk)
    },
    createChatBotMiniVariableGroup (chatbot) {
      let name = this.minibotvarName
      let type = this.varTypeInput
      if (!name) {
        alert('変数名が入力されておりません。入力をお願いいたします。\n（例）$name$')
      } else if (name[0] === "$" && name[name.length - 1] === "$") {
        this.sendControlLogRelatedChatBot('ミニロボ変数作成', '', chatbot)
        for (let mini of chatbot.chatbot_mini) {
          let createChatBotMiniVariableGroupTemp = {
            chatbotmini     : mini.pk,
            variable_name   : name,
            variable_data   : null,
            variable_user   : {
              users: []
            },
            type            : type,
          }
          this.$store.dispatch('chatbot/createChatBotMiniVariableGroup', createChatBotMiniVariableGroupTemp)
        }
        alert('作成しました')
      } else {
        alert('変数名が正しく入力されておりません。\n変数名の先頭と末尾に「$」を入力しているか確認をお願いいたします。')
      }
      this.minibotvarName = null
      this.varTypeInput = 0
    },
    updateChatBotMiniVariableGroup (data) {
      this.sendControlLogRelatedChatBot('ミニロボ変数編集', '', this.cbInfo)
      let updateChatBotMiniVariableGroupTemp = data
      this.$store.dispatch('chatbot/updateChatBotMiniVariableGroup', updateChatBotMiniVariableGroupTemp)
      this.modalFooterVar = null
      this.modalFooterUrl = null
      alert('変更しました')
    },
    deleteChatBotMiniVariableGroup (id) {
      this.$store.dispatch('chatbot/deleteChatBotMiniVariableGroup', id)
    },
    isRoboEditPermission (robo) {
      return isRoboEditPermission(robo, this.user)
    },
    isRoboDisplayPermission (robo) {
      return isRoboDisplayPermission(robo, this.user)
    },
    getTargetUrl (urls) {
      var _urlList = urls ? urls.split('|') : ['']
      var text = ''
      for (var i in _urlList) {
        if (_urlList[i] == 'ALL_RECRUIT_PAGES') {
          text += '求人ページ / カスタムページ（全て）'
        } else if (_urlList[i].indexOf('ALL_') >= 0) {
          text += _urlList[i].substr(4) + '（全て）'
        } else {
          text += _urlList[i]
        }
        text += '\n'
      }
      return text
    },
    isAllUrl (idx, url) {
      if (idx === -1 && url === 'ALL_RECRUIT_PAGES'){
        // 求人ページ
        return this.isAllSelectedEmployment
      } else if (idx === -2 && url === 'ALL_RECRUIT_PAGES'){
        // カスタムページ
        return this.isAllSelectedCustom
      } else if (idx >= 0) {
        // ホームページ
        return this.isAllSelectedHomePage
      }
    },
    getAllUrl (idx) {
      if (idx >= 0 && this.sitemapRootList[idx]) {
        if (this.isAllSelectedHomePage || this.isAllSelectSitemap) {
          this.selectSitemapList = this.sitemapRootList[idx].node_list
        } else {
          this.selectSitemapList = []
        }
      } else if (idx === -1 && this.sitemapRecruitList) {
        // 求人ページ
        if (this.isAllSelectedEmployment || this.isAllSelectSitemap) {
          this.selectSitemapList = this.sitemapRecruitListAll
        } else {
          this.selectSitemapList = []
        }
      } else if (idx === -2 && this.sitemapCustomList) {
        // カスタムページ
        if (this.isAllSelectedCustom || this.isAllSelectSitemap) {
          this.selectSitemapList = this.sitemapCustomListAll
        } else {
          this.selectSitemapList = []
        }
      }
    },
    getSelectColor (cb) {
      for (var i in this.selectedGroup) {
        if (cb.bot_id === this.selectedGroup[i].bot_id) return '#eac'
      }
      return '#fefefe'
    },
    getCONURL (url, index) {
      var a = url.slice(0, 1)
      var b = this.sitemapRootList[index].root_url.slice(-1)
      var conurl = ''
      if (a == b) conurl = this.sitemapRootList[index].root_url + url.slice(1)
      else conurl = this.sitemapRootList[index].root_url + url
      return conurl
    },
    applyRoboSitemap (isMini, isRecruit, action) {
      // ロボの起動設定
      this.isModalUrlSet = false
      let updateList = []
      let selectRoboList = []

      // 選択ロボ
      for (const robo of this.selectedGroup) {
        selectRoboList.push({
          data: {
            'pk'           : robo.pk,
            'name'         : robo.name,
            'bot_id'       : robo.bot_id
          },
          is_mini: isMini
        })
      }
      // サイトマップとロボの紐付け
      for (const sitemap of this.selectSitemapList) {
        updateList.push({
          target: sitemap,
          robo  : selectRoboList
        })
      }
      // 更新付随情報追加
      const updateData = {
        update_list: updateList,
        action     : action,
        is_mini    : isMini,
      }
      // 起動設定画面とフォーマットを合わせる
      if (isRecruit) {
        if (this.tabIdx === -1) {
          this.pageData.content_type = 4
        } else {
          this.pageData.content_type = 5
        }
        const sendData = {
          update_data: updateData,
          page_data  : this.pageData
        }
        this.$store.dispatch('sitemap/updateSitemapEmployment', sendData)
      } else {
        const sendData = {
          update_data: updateData
        }
        this.$store.dispatch('sitemap/updateSitemapNode', sendData)
      }
      this.isAllSelectSitemap = false
      this.isAllSelectedCustom = false
      this.isAllSelectedHomePage = false
      this.groupSelectStep=0
      this.selectedGroup=[]
      this.selectSitemapList=[]
      this.modalFooterUrl = null
    },
    complateUnapplyRoboSitemap (isMini, action) {
      // ロボを全ページから適用解除する
      this.isModalUrlSet = false
      let selectRoboList = []

      // 対象のロボは共通
      for (const robo of this.selectedGroup) {
        selectRoboList.push({
          data: {
            'pk'           : robo.pk,
            'name'         : robo.name,
            'bot_id'       : robo.bot_id
          },
          is_mini: isMini
        })
      }

      // 全サイトマップルートからサイトマップノードを収集する
      if (this.sitemapRootList) {
        let node_list = []
        for (const root of this.sitemapRootList) {
          node_list.concat(root.node_list)
        }
        // サイトマップとロボの紐付け
        let updateList = []
        for (const sitemap of node_list) {
          updateList.push({
            target: sitemap,
            robo  : selectRoboList
          })
        }
        // 更新付随情報追加
        const updateData = {
          update_list: updateList,
          action     : action,
          is_mini    : isMini,
        }
        // 起動設定画面とフォーマットを合わせる
        const sendData = {
          update_data: updateData
        }
        this.$store.dispatch('sitemap/updateSitemapNode', sendData)
      }

      // カスタム含む全求人ページからロボを解除
      if (this.sitemapRecruitListAll.length >= 0 && this.sitemapCustomListAll.length >= 0) {
        let updateList = []
        for (const sitemap of this.sitemapRecruitListAll) {
          updateList.push({
            target: sitemap,
            robo  : selectRoboList
          })
        }
        for (const sitemap of this.sitemapCustomListAll) {
          updateList.push({
            target: sitemap,
            robo  : selectRoboList
          })
        }
        // 更新付随情報追加
        const updateData = {
          update_list: updateList,
          action     : action,
          is_mini    : isMini,
        }
        // // 起動設定画面とフォーマットを合わせる
        // if (this.tabIdx === -1) {
        //   this.pageData.content_type = 4
        // } else {
        //   this.pageData.content_type = 5
        // }
        const sendData = {
          update_data: updateData,
          page_data  : this.pageData
        }
        this.$store.dispatch('sitemap/updateSitemapEmployment', sendData)
      }

      this.isAllSelectSitemap = false
      this.isAllSelectedCustom = false
      this.isAllSelectedHomePage = false
      this.groupSelectStep=0
      this.selectedGroup=[]
      this.selectSitemapList=[]
      this.modalFooterUrl = null
    },
    changeArchive (flg) {
      let archiveFlg = false
      for (let i in this.selectedGroup) {
        let cb = this.selectedGroup[i]
        if (isRoboEditPermission(cb, this.user)) {
          cb.is_archive = flg
          this.$store.dispatch('chatbot/setChatBot', cb)
        } else {
          archiveFlg = true
        }
      }
      if (archiveFlg) {
        if (flg) {
          alert('編集権限のないロボが含まれていました。\n編集権限のあるロボのみをアーカイブしました。')
        } else {
          alert('編集権限のないロボが含まれていました。\n編集権限のあるロボのみを元に戻しました。')
        }
      }
      this.groupSelectStep=0
      this.selectedGroup=[]
    },
    setRecruitPage (flg) {
      for (var i in this.selectedGroup) {
        var cb = this.selectedGroup[i]
        cb.is_recruit = flg
        this.$store.dispatch('chatbot/setChatBot', cb)
      }
      this.groupSelectStep=0
      this.selectedGroup=[]
    },
    getRecruitURL () {
      this.recruitList = []
      for (var i in this.contents) {
        this.recruitList.push({
          url: this.getRecruitUrl(this.contents[i].layout, this.contents[i]),
          contents_id: this.contents[i].contents_id
        })
      }
    },
    getRecruitUrl (type, p) {
      var urlMain = process.env.LOC_HOST + '/recruit/main/' + this.user.companyID
      var urlRecruit = process.env.LOC_HOST + '/recruit/detail/' + this.user.companyID + '/' + p.contents_id
      var urlCustom = process.env.LOC_HOST + '/cstm/' + this.user.companyID + '/' + p.contents_id
      if (type == 0) {
        return urlMain
      } else if (this.isRecruitPage) {
        return urlRecruit
      } else {
        return urlCustom
      }
    },
    getSubStrRecruit (url, id, idx) {
      if (url == undefined) return ''
      else if (url.indexOf('/recruit/main/') >= 0) return '会社概要ページ'
      for (var i in this.contents) {
        if (this.contents[i].contents_id == id) {
          if (this.contents[i].title && idx === -2) {
            return this.contents[i].title
          } else if (this.contents[i].content.title && idx === -1) {
            return this.contents[i].content.title
          } else {
            return 'No Title'
          }
        }
      }
    },
    selectsAll (flg) {
      if (flg) this.selectedGroup = this.chatbots
      else this.selectedGroup = []
    },
    selectsDelete () {
      var result = confirm(this.selectedGroup.length + '体、ロボを削除します。本当によろしいですか？\n(編集権限のないロボは削除されません。)')
      if (result) {
        for (var i in this.selectedGroup) {
          if (isRoboEditPermission(this.selectedGroup[i], this.user)) {
            this.$store.dispatch('chatbot/deleteChatBot', { companyid: this.user.companyID, chatbotID: this.selectedGroup[i].bot_id })
          }
        }
        this.selectedGroup = []
        alert('削除しました。')
      }
    },
    makeLink (name) {
      return process.env.OWN_ENDPOINT + '/single/demo/' + this.user.companyID + '/' + name
    },
    makeLinkMini (name, mini) {
      return process.env.OWN_ENDPOINT + '/single/demo/' + this.user.companyID + '/' + name + '/' + mini.pk
    },
    openStore () {
      var h = window.outerHeight
      var w = window.outerWidth / 2
      window.open('/store', '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
    },
    changeList () {
      this.isScenarioList = false
      this.isChatbotList = true
      this.isSitemap = false
      this.isMenuOpen = false
      this.$router.push('/dashboard/chatbot')
    },
    setScenarioName (scenarioName, chatbot) {
      this.isAdd = false
      this.isScenarioList = true
      this.isChatbotList = false
      this.isSitemap = false
      this.isMenuOpen = false
      this.$store.dispatch('chatbot/getChatBots')
      this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
      this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: scenarioName })
      this.$store.dispatch('chatbot/selectChatbot', chatbot)
      this.addName = ''
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + scenarioName)
    },
    dispRoboPartsSetView (roboPartsSet) {
      this.isAdd = false
      this.isScenarioList = true
      this.isChatbotList = false
      this.isMenuOpen = false
      this.$store.dispatch('chatbot/scenarioPastCancel')
      this.$store.dispatch('chatbot/dispRoboPartsSetView', roboPartsSet)
      this.addName = ''
      this.$router.push('/dashboard/chatbot?view=scenario')
      this.isParts = true
      this.isTemplate = false
      this.isChatbotInfo = false
    },
    /** 新規パーツセット作成 */
    createRoboPartsSet () {
      if (!this.roboPartsSetName || !this.author) {
        alert("パーツセット名と作成者を入力してください")
        return
      }
      const data = {
        robo_parts_set_name: this.roboPartsSetName,
        company: this.user.companyID,
        author: this.author
      }
      this.$store.dispatch('chatbot/createRoboPartsSet', data)

      this.roboPartsSetName = null
      this.author = null
      this.isCreateRoboPartsSetModal = false
    },
    changeSitemap () {
      this.clearModalInfo()
      this.isSitemap = true
      this.isChatbotList = false
      this.isScenarioList = false
      this.isMenuOpen = false
      this.$router.push('/dashboard/chatbot?view=sitemap')
    },
    openStoreUpload (cbInfo) {
      this.$refs.storeup.cbInfo = cbInfo
      this.$refs.storeup.isCardModalActive = true
    },
    createChatBot () {
      this.$refs.create.isCardModalActive = true
    },
    deleteChatBot (id) {
      this.$refs.delete.chatBotDeleteFlag = true
      this.deleteIndex = id
    },
    editChatBot (index) {
      this.editIndex = index
      this.$refs.edit.chatBotEdit = true
      this.originalChatBot = Object.assign({}, this.chatbots[index])
    },
    saveChatBotsOrder (chatbots) {
      let obj = []
      let cbs = chatbots
      for (let i in cbs) {
        cbs[i].order_num = Number(i) + 1
        obj.push(cbs[i])
      }
      this.$store.dispatch('chatbot/updateOrderChatbot', obj)
    },
    showChatBotStatus (chatbot) {
      this.$store.dispatch('chatbot/getChatBotStatus', chatbot.bot_id)
    },
    showInfoView (chatbot, index) {
      if (!chatbot) chatbot = this.selectChatbot
      this.cbInfo = chatbot
      this.cbInfoIndex = chatbot.bot_id
      this.showChatBotStatus(chatbot)
      if (chatbot.permit_users) {
        if (chatbot.permit_users.users) this.permitList = chatbot.permit_users.users
        else this.permitList = []
      } else {
        this.permitList = []
      }
      this.isChatbotInfo = true
      this.counter = 0
      this.$store.dispatch('chatbot/getScenarioList', { companyid: chatbot.group, scenarioName: chatbot.scenario_name })
      .then((d) => {
        setTimeout(() => {
          this.scenario = this.$_.cloneDeep(d.data)
          this.allPartsConfirm = true
          for (var i of this.scenario) {
            if (!i.is_confirm) {
              this.allPartsConfirm = false
            }
          }
        }, 200)
      })
    },
    getScore(cbInfo) {
      var score = 0
      score += cbInfo.message_count * 0.1
      score += cbInfo.appoint_count * 2
      score += cbInfo.reply_count * 0.1
      score += cbInfo.subscribe_count * 10
      return score
    },
    getScoreCB(cbInfo) {
      var score = 0
      score += cbInfo.send_power * 0.1
      score += cbInfo.select_power * 2
      score += cbInfo.receive_power * 0.1
      score += cbInfo.subscribe_power * 10
      return (score / 20)
    },
    checkURL (url) {
      if (url.length > 0) return url
      else return '入力なし'
    },
    clickTriangle (url){
      if (url.length > 0) {
        url = url.split('|')
        return url
      } else{
        return ''
      }
    },
    showDate (date) {
      return new Date(date).getUTCFullYear() + '/' + (new Date(date).getUTCMonth() + 1) + '/' + new Date(date).getUTCDate()
    },
    activeTab (flg) {
      if (flg) return 'black'
    },
    dragScenarioParts (i, event) {
      this.$store.dispatch('chatbot/changeIsDrop', i)
    },
    dragRoboPartsSet (s, event) {
      const data = {
        index: 100,
        roboPartsSet: s
      }
      this.$store.dispatch('chatbot/changeIsDropList', data)
    },
    resetDrag () {
      this.$store.dispatch('chatbot/changeIsDrop', -1)
    },
    resetDragList () {
      const data = {
        index: -1,
        roboPartsSet: null
      }
      this.$store.dispatch('chatbot/changeIsDropList', data)
    },
    setBot (chatbot) {
      this.cb = chatbot
    },
    hoverSelect (scnName, flg) {
      this.isDetailHover = flg
      this.detailScnName = scnName
    },
    copySinglePageURL (chatbot) {
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + chatbot.bot_id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    copySinglePageURLMini (chatbot, mini) {
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + this.user.companyID + '/' + chatbot.bot_id + '/' + mini.pk
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    uploadStoreItem (bot) {
      var cb = bot
      cb['name'] = this.storeItemName
      cb['category'] = this.storeItemCategory
      cb['detail'] = this.storeItemDetail
      cb['message_count'] = this.chatbotStatus.message_count
      cb['appoint_count'] = this.chatbotStatus.appoint_count
      cb['reply_count'] = this.chatbotStatus.reply_count
      cb['subscribe_count'] = this.chatbotStatus.subscribe_count
      this.$store.dispatch('chatbot/createChatBotStoreItem', cb)
      this.storeItemName = ''
      this.storeItemCategory = ''
      this.isChatbotStore = false
    },
    downloadDialog (bots) {
      this.$refs.talkDownload.bots = bots
      this.$refs.talkDownload.isCardModalActive = true
    },
    importBot (file, id) {
      this.$store.dispatch('chatbot/importBot', {id: id, file: file})
    },
    exportBot (bot) {
      this.$store.dispatch('chatbot/exportBot', {company_id: bot.group, id: bot.bot_id})
      this.selectedGroup = []
    },
    getFilteredTags (text) {
      return this.categoriesTags
    },
    modalActive (isMini, miniIdx) {
      this.isMini  = isMini
      this.miniIdx = miniIdx
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    deleteIcon (isMini, miniIdx) {
      this.isMini  = isMini
      this.miniIdx = miniIdx
      this.setIcon(null)
    },
    setIcon (id) {
      // ミニロボの画像変更とそれ以外
      if (this.isMini) {
        let updateChatBotMiniTemp = this.cbInfo.chatbot_mini[this.miniIdx]
        if (id) {
          for (const i of this.images) {
            if (i.image_id == id) {
              updateChatBotMiniTemp["icon_ref"] = i.pk
              updateChatBotMiniTemp["icon_data"] = i.image_data
              this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
              break
            }
          }
        } else {
          updateChatBotMiniTemp["icon_ref"] = null
          updateChatBotMiniTemp["icon_data"] = null
          this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
        }
      } else {
        this.$store.dispatch('chatbot/setChatBotIcon',{name: this.cbInfo.name, id:this.cbInfo.bot_id, image_id:id})
          .then((d) => { this.cbInfo.icon_data = d })
      }
    },
    mainBotActionTable (cbInfo) {
      this.selectBotName = cbInfo.name
      this.botNameClick = true
      // seekerを全員列挙
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (this.seekerIds.indexOf(seekerInputInfo.seeker_id) === -1 && seekerInputInfo.cb_type === "main") {
          this.seekerIds.push(seekerInputInfo.seeker_id)
          this.seekerSortedInfos[seekerInputInfo.seeker_id] = []
        }
      }
      // seekerごとに入力情報を持たせる
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (seekerInputInfo.cb_type === "main") {
          this.seekerSortedInfos[seekerInputInfo.seeker_id].push(seekerInputInfo)
        }
      }
      this.sortSeekerItems()
    },
    miniBotActionTable (mini) {
      this.selectBotName = mini.name
      this.botNameClick = true
      // seekerを全員列挙
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (this.seekerIds.indexOf(seekerInputInfo.seeker_id) === -1 && seekerInputInfo.cbmini_id === mini.bot_id) {
          this.seekerIds.push(seekerInputInfo.seeker_id)
          this.seekerSortedInfos[seekerInputInfo.seeker_id] = []
        }
      }
      // seekerごとに入力情報を持たせる
      for (let seekerInputInfo of this.seekerInputInfos) {
        if (seekerInputInfo.cbmini_id === mini.bot_id) {
          this.seekerSortedInfos[seekerInputInfo.seeker_id].push(seekerInputInfo)
        }
      }
      this.sortSeekerItems()
    },
    sortSeekerItems () {
      for (let i in this.seekerIds) {
        let seekerName = ''
        let date = ''
        for (let j in this.seekerSortedInfos[this.seekerIds[i]]) {
          seekerName = this.seekerSortedInfos[this.seekerIds[i]][j].seeker_name
          date = new Date(this.seekerSortedInfos[this.seekerIds[i]][j].created_at).toLocaleString('ja-JP')
        }
        this.seekerItems.push(
          {seekerId: this.seekerIds[i], seekerName: seekerName, latestDate: date}
        )
      }
    },
    resetSeekerrSortedInfosState () {
      this.botNameClick = false
      this.seekerIds = []
      this.seekerSortedInfos = {}
      this.selectBotName = ''
      this.seekerItems = []
    },
    // ロボが起動しているかどうか
    isOnBot (chatbot) {
      // ロボの起動設定チェック
      if (!chatbot.chatbot_mini) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const recruit of this.sitemapRecruitList) {
          for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
        for (const custom of this.sitemapCustomList) {
          for (const robo of custom.apply_robo_list.concat(custom.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else if (chatbot.chatbot_mini.length < 1) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const recruit of this.sitemapRecruitList) {
          for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
        for (const custom of this.sitemapCustomList) {
          for (const robo of custom.apply_robo_list.concat(custom.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else {
        // ミニロボを持っている場合
        for (const mini of chatbot.chatbot_mini) {
          for (const root of this.sitemapRootList) {
            for (const sitemap of root.node_list) {
              for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
                if (robo.data.bot_id === chatbot.bot_id) {
                  return true
                }
              }
            }
          }
          for (const recruit of this.sitemapRecruitList) {
            for (const robo of recruit.apply_robo_list.concat(recruit.apply_minirobo_list)) {
              if (robo.data.bot_id === mini.bot_id) {
                return true
              }
            }
          }
          for (const custom of this.sitemapCustomList) {
            for (const robo of custom.apply_robo_list.concat(custom.apply_minirobo_list)) {
              if (robo.data.bot_id === mini.bot_id) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    hasMiniBot (selectedGroup) {
      // ミニロボ有無チェック
      let hasMini = false
      for (const bot of selectedGroup) {
        if (bot.chatbot_mini.length > 0) {
          // １つでもミニロボありのロボがあればtrue
          hasMini = true
          break
        }
      }
      return hasMini
    },
    clearModalInfo () {
      this.isModalAddMiniBot       = false
      this.isModalUrlSet           = false
      this.isModalUrlSetBot        = false
      this.isModalUrlSetMiniBot    = false
      this.isModalUrlDeleteBot     = false
      this.isModalUrlDeleteMiniBot = false
      this.isChatbotInfo           = false
      this.isModalStartURL         = false
      this.setShowURL              = ''
      this.selectedGroup           = []
      this.groupSelectStep         = 0
      this.modalFooterUrl          = null
      this.modalFooterVar          = null
    },
    cancelModalInfo () {
      this.isModalAddMiniBot       = false
      this.isModalUrlSet           = false
      this.isModalUrlSetBot        = false
      this.isModalUrlSetMiniBot    = false
      this.isModalUrlDeleteBot     = false
      this.isModalUrlDeleteMiniBot = false
    },
    alterReplace (msg, dir) {
      return alterReplace(msg, dir)
    },
    headerTitleChange () {
      this.sendControlLogRelatedChatBot('ロボ設定変更', 'ロボの設定を変更', this.cbInfo)
      this.$store.dispatch('chatbot/setChatBot', this.cbInfo)
    },
    clickRoboLock (cb) {
      cb.is_confirm = !cb.is_confirm
      this.$store.dispatch('chatbot/setChatBot', cb)
    },
    getSitemapRoboList () {
      this.$store.dispatch('sitemap/getSitemapRoboList')
    },
    errorCheck (scenario) {
      const errorList = []
        const errorCountList = {
          isStartErrorCount      : this.isStartErrorCount(scenario),
          isGoalErrorCount       : this.isGoalErrorCount(scenario),
          isImageErrorCount      : this.isImageErrorCount(scenario),
          isMovieErrorCount      : this.isMovieErrorCount(scenario),
          isEmailErrorCount      : this.isEmailErrorCount(scenario),
          isSmsErrorCount        : this.isSmsErrorCount(scenario),
          isDownloadErrorCount   : this.isDownloadErrorCount(scenario),
          isChangeRoboErrorCount : this.isChangeRoboErrorCount(scenario),
          isNextRoboErrorCount   : this.isNextRoboErrorCount(scenario),
          isIfErrorCount         : this.isIfErrorCount(scenario),
          isIfQuoteErrorCount    : this.isIfQuoteErrorCount(scenario),
          isIfUserInfoErrorCount : this.isIfUserInfoErrorCount(scenario),
          isPdfDownloadErrorCount: this.isPdfDownloadErrorCount(scenario)
        }
        return this.createErrorList(errorList, errorCountList)
    },
    createErrorList (errorList, errorCountList) {
      for (const k in errorCountList) {
        for (let i = 0; i < errorCountList[k]; i++) {
          switch (k) {
            case 'isStartErrorCount':
              errorList.push('・開始設定がされていません')
              break;
            case 'isGoalErrorCount':
              errorList.push('・GOAL設定がされていません')
              break;
            case 'isImageErrorCount':
              errorList.push('・画像が設定されていない画像表示パーツがあります')
              break;
            case 'isMovieErrorCount':
              errorList.push('・動画が設定されていない動画パーツがあります')
              break;
            case 'isEmailErrorCount':
              errorList.push('・メール送付パーツの宛先が設定されていません')
              break;
            case 'isSmsErrorCount':
              errorList.push('・SMS送付パーツの宛先が設定されていません')
              break;
            case 'isDownloadErrorCount':
              errorList.push('・ファイルダウンロードパーツのファイルが設定されていません')
              break;
            case 'isChangeRoboErrorCount':
              errorList.push('・ロボ切替パーツのロボが設定されていません')
              break;
            case 'isNextRoboErrorCount':
              errorList.push('・ロボ切替パーツの選択ロボが確定されていません')
              break;
            case 'isIfErrorCount':
              errorList.push('・条件で分けるパーツの条件が設定されていません')
              break;
            case 'isIfQuoteErrorCount':
              errorList.push('・条件で分けるパーツの「条件とするパーツ」が存在しないか、到達できません')
              break;
            case 'isIfUserInfoErrorCount':
              errorList.push('・条件で分けるパーツの「条件とする項目」がロボ引用設定に設定されていません')
              break;
            case 'isPdfDownloadErrorCount':
              errorList.push('・PDFダウンロードパーツの出力項目が設定されていません')
          }
        }
      }
      return errorList
    },
    isStartErrorCount (scenario) {
      if (scenario.filter(v => v.start_flg).length) return 0
      else return 1
    },
    isGoalErrorCount (scenario) {
      if (scenario.filter(v => v.is_cv).length) return 0
      else return 1
    },
    isImageErrorCount (scenario) {
      return scenario.filter(v => v.status == 5 && v.image === '' ).length
    },
    isMovieErrorCount (scenario) {
      return scenario.filter(v => v.status == 14 && v.parameter.filename === '' && v.parameter.url === '').length
    },
    isEmailErrorCount (scenario) {
      return scenario.filter(v => v.status == 10 && v.parameter.to === '').length
    },
    isSmsErrorCount (scenario) {
      return scenario.filter(v => v.status == 16 && v.parameter.to === '').length
    },
    isDownloadErrorCount (scenario) {
      return scenario.filter(v => v.status == 18 && !v.parameter.filename.length).length
    },
    isChangeRoboErrorCount (scenario) {
      return scenario.filter(v => v.status == 3 && !("bot_id" in v.parameter)).length
    },
    isNextRoboErrorCount (scenarioTable) {
      let errorCount = 0
      const parameters = scenarioTable.filter(v => v.status == 3).map(v => v.parameter)
      for (const parameter of parameters) {
        for (const c of this.chatbots) {
          if (parameter.bot_id == c.bot_id) {
            if (!c.is_confirm) {
              errorCount++
              break
            }
          } 
        }
      }
      return errorCount
    },
    isIfErrorCount (scenario) {
      // 条件で分けるはrandomを選択しておらず、ポイント、ワード、応募者情報、ミニロボ変数のどれもtermsを登録してない場合に条件が設定されていないエラーを出す
      let errorCount = 0
      const parameters = scenario.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        for (const p of parameter.filter(v => !v.random)) {
          let isNotPoint = false
          let isNotWord = false
          let isNotUserInfo = false
          let isNotMiniRobo = false
          for (const pointList of p.pointList) {
            if (pointList.terms === '') isNotPoint = true
          }
          for (const wordList of p.wordList) {
            if (wordList.terms === '') isNotWord = true
          }
          if (p.userInfoList) {
            for (const userInfoList of p.userInfoList) {
              if (userInfoList.terms === '') isNotUserInfo = true
            }
          }
          else {
            isNotUserInfo = true
          }
          if (p.miniroboVarsList) {
            for (const miniroboVarsList of p.miniroboVarsList) {
              if (miniroboVarsList.terms === '') isNotMiniRobo = true
            }
          }
          else {
            isNotMiniRobo = true
          }
          if (isNotPoint && isNotWord && isNotUserInfo && isNotMiniRobo) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isIfQuoteErrorCount (scenario) {
      // 「条件とするパーツ」が存在しない or 到達できないならエラー
      let errorCount = 0

      const next_nodes = {}
      for (let s of scenario) next_nodes[s.beforenode] = s.select.filter(sel => sel.next_node).map(sel => sel.next_node)

      const start_scenario = scenario.find(i => i.start_flg)
      if (!start_scenario) return 0
      const start_node = start_scenario.beforenode

      const end_nodes = scenario.filter(s => s.is_cv).map(s => s.beforenode)

      //開始ノードから各ノードへ、必ず通るノードを集計
      //スタートへ戻ってくるパスとゴールから先のパスは考慮しない
      let route = {[start_node]: []}
      let queue = [start_node]
      while(queue.length!=0) {
        const node = queue.shift()
        if (end_nodes.includes(node)) continue
        for (const next of next_nodes[node]) {
          const temp_route = [node].concat(route[node])
          if (!(next in route)) {
            route[next] = temp_route
            queue = queue.filter(n => n!=next)
            queue.push(next)
          }
          else {
            const pre_size = route[next].length
            route[next] = route[next].filter(n => temp_route.includes(n))
            if (pre_size != route[next].length) {
              queue = queue.filter(n => n!=next)
              queue.push(next)
            }
          }
        }
      }
      
      const if_scenarios = scenario.filter(v => v.status == 12 && v.parameter[0].wordList[0].terms)

      //開始ノードから当該分岐パーツまでの間に、必ず「条件とするパーツ」が含まれるかどうか
      for (const if_scenario of if_scenarios) {
        const if_node = if_scenario.beforenode
        if (!route[if_node]) continue
        for (let param of if_scenario.parameter) {
          if (!Number(param.wordList[0].parts)) continue
          const target_scenario = scenario.find(s => s.pk == param.wordList[0].parts)
          if (!target_scenario) {errorCount++;break}
          const target_node = target_scenario.beforenode
          if (!route[if_node].includes(target_node)) {errorCount++;break}
        }
      }

      return errorCount
    },
    isIfUserInfoErrorCount (scenario) {
      // 「条件とする項目」がロボ引用設定に設定されていない場合エラー
      let errorCount = 0
      const parameters = scenario.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        if (!parameter[0].userInfoList || parameter[0].userInfoList[0].terms === '') continue
        for (const p of parameter) {
          if (!this.selectChatbot.robo_arguments.map(column => column.pk).includes(p.userInfoList[0].column_pk)) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isPdfDownloadErrorCount (scenario) {
      return scenario.filter(v => v.status == 21 && v.parameter.item_list === '').length
    },
  },
  watch: {
    pages () {
      if (this.$route.query.pages) {
        if (this.$route.query.pages >= 1) {
          if (this.tabIdx === -1) {
            this.recruitPages = this.pages
            this.contentsCount = this.countRecruitPage
            const pageData = {
              pages  : this.pages,
              per_page: 30,
              content_type: 4
            }
            this.$store.dispatch('sitemap/getSitemapRecruitList', pageData)
          } else if (this.tabIdx === -2) {
            this.customPages = this.pages
            this.contentsCount = this.countCustomPage
            const pageData = {
              pages  : this.pages,
              per_page: 30,
              content_type: 5
            }
            this.$store.dispatch('sitemap/getSitemapCustomList', pageData)
          }
          this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
          this.$router.push('/dashboard/chatbot?pages=' + this.pages + '&recruit=' + this.isRecruitPage)
        }
      }
    },
    tabIdx () {
      if (this.tabIdx === -1) {
        this.pages = this.recruitPages
        this.contentsCount = this.countRecruitPage
      } else if (this.tabIdx === -2) {
        this.pages = this.customPages
        this.contentsCount = this.countCustomPage
      }
    },
    isRecruitPage () {
      this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
      this.$router.push('/dashboard/chatbot?pages=' + this.pages + '&recruit=' + this.isRecruitPage)
    },
    contents () {
      this.recruitList = []
      for (var i in this.contents) {
        this.recruitList.push({
          url: this.getRecruitUrl(this.contents[i].layout, this.contents[i]),
          contents_id: this.contents[i].contents_id
        })
      }
    },
    chatbots () {
      // alert('c: ' + this.scenarioTable.length + '| ct: ' + this.chatbots.length)
      if (this.$route.query.scenario) {
        // if ((this.scenarioTable.length === 0 && this.chatbots.length > 0)) {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.$route.query.scenario })
        for (var i in this.chatbots) {
          if (this.chatbots[i].scenario_name == this.$route.query.scenario) this.$store.dispatch('chatbot/selectChatbot', this.chatbots[i])
        }
        // }
      }
    },
    csvFile () {
      if (this.csvFile != null) {
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var blob = new Blob([bom, this.csvFile], { "type" : "text/csv" })
        var downLoadLink = document.createElement('a')
        downLoadLink.download = '会話履歴.csv'
        downLoadLink.href = URL.createObjectURL(blob)
        downLoadLink.dataset.downloadurl = ['text/csv', downLoadLink.download, downLoadLink.href]
        downLoadLink.click()
      }
    },
    getallroom (url) {
      var search = {
        'get_type': 'query',
        'query_url_direct': url
      }
      this.$store.dispatch('directtalk/getRoomList', search)
    },
    isChatbotInfo () {
      if (this.isChatbotInfo === true) {
        this.resetSeekerrSortedInfosState()
        this.$store.dispatch('directtalk/fetchSeekerInputInfo', this.cbInfo)
      }
    }
  }
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  overflow: scroll;
  height: calc(100% - 100px);
  table-layout: fixed;
}
table::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
}
td {
  text-align: left;
  overflow: scroll;
  padding: 8px;
}
td > div::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}

.header-cb {
  margin: 10px 20px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}

.header-cb > div {
  display: flex;
  align-items: center;
}

.plan-tag {
  position: fixed;
  top: 80px;
  padding: 24px;
  font-size: 20px;
  font-weight: 600;
  color: white;
  background: rgba(0, 0, 0, 0.9);
  text-align: left;
  z-index: 1000000;
  width: calc(100% - 200px);
}

.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.tabs-list {
  padding: 0px;
  color: #F8F8F8;
}
.tabs-list:hover {
  color: #F2DEF2;
}
.tabs::-webkit-scrollbar {
  width: 15px;
  height: 15px;
  visibility: hidden;
}

.tab-container {
  margin: 0;
  overflow: scroll;
  height: 100vh;
  width: calc(100% - 200px);
  background: #FEFEFE;
}
.fade-enter-active {
  transition: opacity .5s, transform .5s;
}
.fade-enter {
  opacity: 0;
  transform: translateY(0px);
}

.from-store {
  background: rgba(215, 234, 241, 1);
  color: black;
}

.from-store-icon {
  position: absolute;
  bottom: 10px;
  right: 15px;
  font-size: 23px;
  color: #666;
}

/* ロボの部分 */
.cb-card {
  width: calc(50% - 50px);
  height: 128px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 5px 20px;
  margin-bottom: 0;
  padding: 15px 5px;
  padding-bottom: 20px;
  border-bottom: dotted 2px #bbb;
  transition: 0.5s;
}

@media screen and (max-width: 1100px) {
  .cb-card {
    width: calc(100% - 100px);
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 15px 20px;
    padding: 15px 5px;
    border-bottom: dotted 2px #bbb;
    transition: 0.5s;
  }
}

.btn-circle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border-radius: 50%;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  overflow : hidden;
	outline : none;
  z-index: 30;
  background: white;
  filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.6));
}

.pos-one {
  font-size: 11px;
  bottom: 270px;
  width: 100px;
  border-radius: 15px;
}

.pos-two {
  font-size: 11px;
  bottom: 180px;
  width: 100px;
  border-radius: 15px;
}

.pos-three {
  font-size: 11px;
  bottom: 90px;
  width: 100px;
  border-radius: 15px;
}

.pos-above {
  font-size: 11px;
  bottom: 20px;
  right: 150px;
  width: 100px;
  border-radius: 15px;
}

.menu-filter {
  width: 100vw;
  height: 100vh;
  z-index: 1;
  position: fixed;
  bottom: 0; left: 0;
  background: rgba(0, 0, 0, 0.15);
  background: linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.25));
}

.content-container-chatbot {
  overflow-y: scroll;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: calc(100vh - 250px);
  padding: 10px 0;
}

.content-container-chatbot::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}

.body-setting::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}

.scenario-button {
  border: none;
  outline: 0;
  border-top: solid thin #ccc;
  max-width: 210px;
  min-width: 210px;
  color: #56b7dd;
  padding: 12px;
}

.content-container-scenario {
  height: calc(100vh - 80px);
  overflow-x: scroll;
  overflow-y: hidden;
  width: calc(100vw - 200px);
  justify-content: space-around;
}

.create-button {
  min-width: 100vw;
  max-width: 100vw;
  padding: 20px;
  justify-content: flex-start;
  text-align: left;
}

.img-icon > img {
  display:    block;
  min-width:  75px;
  min-height: 75px;
  width:      75px;
  height:     75px;
  max-width:  75px;
  max-height: 75px;
  border-radius: 50%;
  object-fit: cover;
  background: white;
}

.img-icon-128px > img {
  display:    block;
  min-width:  128px;
  min-height: 128px;
  width:      128px;
  height:     128px;
  max-width:  128px;
  max-height: 128px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  background: white;
}

.title-menu {
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-bottom: solid thin #ccc;
}
.menu-button {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  color: rgb(53, 47, 53) !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.menu-list {
  height: calc(100vh - 100px);
  width: 200px;
  overflow-y: scroll;
  padding-bottom: 70px;
  text-align: left;
  font-size: 14px;
}
.menu-list a:hover {
  background-color: rgb(244, 204, 219) !important;
}
.menu-list::-webkit-scrollbar {
  width:  5px !important;
  height: 5px !important;
  visibility: visible !important;
}
.active-menu {
  background-color: rgb(244, 204, 219) !important;
  padding-left: 15px;
}
.menu-box {
  background: #fff;
  border-right: solid thin #ccc;
  width: 200px;
  height: calc(100vh - 80px);
}
.scenario-content {
  background: #fff;
  width: calc(100vw - 400px);
  height: calc(100vh - 80px);
  display: flex;
}
.scenario-content-balloon {
  background: #fbfbfb;
  border-radius: 15px;
  width: 45vw;
  height: 65vh;
  padding: 20px;
  position: fixed;
  top:  15%;
  left: 25%;
  border: solid 3px #555;
  z-index: 2000000;
}
.setting-content {
  background: #fff;
  width: 200px;
  height: calc(100vh - 80px);
  justify-content: center;
  align-items: flex-start;
}
.header-setting {
  display: flex;
  height: 50px;
  flex-wrap: nowrap;
  justify-content: space-between;
  border-left: solid thin #ccc;
  border-bottom: solid thin #ccc;
  align-items: center;
  padding: 0.5em;
}
.body-setting {
  height: calc(100vh - 130px);
  overflow: scroll;
  border-left: solid thin #ccc;
  background: #FEFEFE;
}
.card-header-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.img-icon-parts {
  display: block;
  object-fit: cover;
  height: 100%;
  width: 100%;
  max-height: 96px;
  max-width: 96px;
  margin: 0;
}
.icon-modify > input {
  display: none;
}
.link-button {
  position: absolute;
  top: 155px;
  left: 10px;
  padding: 10px;
  border-radius: 50%;
}
.status-button {
  position: absolute;
  top: 162.5px;
  left: 65.5px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 15px;
  text-align: center;
  background: #00CBCB;
  color: white;
  font-weight: 700;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-top-btn-enter-active, .slide-top-btn-leave-active {
  transition: transform .6s;
}
.slide-top-btn-enter, .slide-top-btn-leave-to {
  opacity: 0;
  transform: translateY(80px);
}

.slide-left-btn-enter-active, .slide-left-btn-leave-active {
  transition: transform .6s;
}
.slide-left-btn-enter, .slide-left-btn-leave-to {
  opacity: 0;
  transform: translateX(80px);
}

.slide-top-enter-active, .slide-top-leave-active {
  transition: transform .8s;
}
.slide-top-enter, .slide-top-leave-to {
  opacity: 0;
  transform: translateY(70vh);
}

.mask {
  position: fixed;
  width: 100%;
  height:100%;
  background-Color: black;
  padding: 0px;
  top: 0px;
  left: 0px;
  opacity: 0.2;
  z-index: 20000;
  pointer-events: none;
}
.create-card {
  border-radius: 5px;
  max-width: 210px;
  min-width: 210px;
}
.load-display {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: white;
  height: 90%;
  width: 90%;
  border-radius: 15px;
  margin: -15px;
}
.init-message {
  padding: 20px;
  display:flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  background: ghostwhite;
  margin: 10px;
  font-weight: 800;
  border-radius: 15px;
}
.arrow-r:before,
.arrow-l:before
{
    position: relative;
    display: block;
    margin: auto;
    top: 44%;
    width: 0px;
    height: 0px;
    border: 5px solid transparent;
    border-right-color: #666;
    border-top-color: #666;
    content: "";
}
.arrow-r:before {
    margin-left: 12%;
    margin-top: -30%;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
.arrow-l:before {
    margin-left: 36%;
    margin-top: -30%;
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
}

.arrow2-r:before,
.arrow2-l:before
{
    position: relative;
    display: block;
    margin: auto;
    top: 44%;
    width: 0px;
    height: 0px;
    border: 5px solid transparent;
    border-right-color: #fff;
    border-top-color: #fff;
    content: "";
}
.arrow2-r:before {
    margin-left: 12%;
    margin-top: -30%;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}
.arrow2-l:before {
    margin-left: 36%;
    margin-top: -30%;
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
}
.select-footer {
  position: fixed;
  bottom: 0;
  left: 200px;
  z-index: 40;
  width: calc(100vw - 200px);
  height: 150px;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  transition: 0.5s;
}
.message-box {
  margin-left: 20px;
  height: 90px;
  width: calc(100% - 160px);
  border: solid 3px white;
  border-radius: 15px;
  border-top-left-radius: 0px;
  overflow-y: scroll;
  text-align: left;
  padding: 10px 20px;
  transition: 0.5s;
}
.scroll-url {
  height: 210px;
  overflow: auto;
}
.scroll-url::-webkit-scrollbar {
  width:  15px !important;
  height: 15px !important;
  visibility: visible !important;
}
/* 初期ページ用 -- start -- */
.init-page {
  position: absolute;
  padding: 15px 45px;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.menu-btn {
  padding: 0;
  height: 35px;
  width: 35px;
  font-size: 20px;
  border-radius: 0px;
  border-color: rgb(174, 44, 152);
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.display-none {
  display: none;
}
.bot-name:hover {
  color:#EE2C98;
}
.item-box {
  width: 200px;
  height: 100%;
  border: 1px solid #dbdbdb;
  padding: 8px;
  border-right: 1px transparent solid;
  margin-right: -1px;
}
.item-box:last-child {
  border-right: 1px solid #dbdbdb;
}
.line {
  display: flex;
  overflow-x: scroll;
}
.line::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.list-container {
  height: 280px;
  margin-top: 8px;
  overflow-y: auto;
}
.list-container::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.mini-bots-wrapper {
  height: 240px;
  overflow-y: auto;
}
.mini-bots-wrapper::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.seeker-item::before{
  content : "" ;
  position : absolute ;
  top : 0 ;
  left : 0 ;
  width : 100% ;
  height : 100% ;
  border: solid 1px #dbdbdb;
}
.chatbot-icon {
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
  cursor: pointer;
}
.delete-button {
  position: absolute;
  top:   -180px;
  right:  180px;
  height: 20px;
  width:  20px;
  border-radius: 50%;
  line-height: 0.95;
  border: solid thin #ccc;
  background: rgb(255, 255, 255);
  cursor: pointer;
}
.mini-delete-button {
  position: absolute;
  top:    0px;
  right:  0px;
  height: 20px;
  width:  20px;
  border-radius: 50%;
  line-height: 0.95;
  border: solid thin #ccc;
  background: rgb(255, 255, 255);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ChatBotList.vue